var ChinaCitys = 
[
  {
    "value": "北京市",
	 "label": "北京市",
    "children": [
      {
        "city": "北京市",
		  "value": "北京市",
		  "label": "北京市",
        "children": [
          {
            "value": "东城区"
          },
          {
            "value": "西城区"
          },
          {
            "value": "朝阳区"
          },
          {
            "value": "丰台区"
          },
          {
            "value": "石景山区"
          },
          {
            "value": "海淀区"
          },
          {
            "value": "门头沟区"
          },
          {
            "value": "房山区"
          },
          {
            "value": "通州区"
          },
          {
            "value": "顺义区"
          },
          {
            "value": "昌平区"
          },
          {
            "value": "大兴区"
          },
          {
            "value": "怀柔区"
          },
          {
            "value": "平谷区"
          },
          {
            "value": "密云区"
          },
          {
            "value": "延庆区"
          }
        ]
      }
    ]
  },
  
  {
    "value": "天津市",
	 "label": "天津市",
    "children": [
      {
        "city": "天津市",
		  "value": "天津市",
		  "label": "天津市",
        "children": [
          {
            "value": "和平区"
          },
          {
            "value": "河东区"
          },
          {
            "value": "河西区"
          },
          {
            "value": "南开区"
          },
          {
            "value": "河北区"
          },
          {
            "value": "红桥区"
          },
          {
            "value": "东丽区"
          },
          {
            "value": "西青区"
          },
          {
            "value": "津南区"
          },
          {
            "value": "北辰区"
          },
          {
            "value": "武清区"
          },
          {
            "value": "宝坻区"
          },
          {
            "value": "滨海新区"
          },
          {
            "value": "宁河区"
          },
          {
            "value": "静海区"
          },
          {
            "value": "蓟州区"
          }
        ]
      }
    ]
  },
  
  {
    "value": "河北省",
	 "label": "河北省",
    "children": [
      {
        "city": "石家庄市",
		  "value": "石家庄市",
		  "label": "石家庄市",
        "children": [
          {
            "value": "长安区"
          },
          {
            "value": "桥西区"
          },
          {
            "value": "新华区"
          },
          {
            "value": "井陉矿区"
          },
          {
            "value": "裕华区"
          },
          {
            "value": "藁城区"
          },
          {
            "value": "鹿泉区"
          },
          {
            "value": "栾城区"
          },
          {
            "value": "井陉县"
          },
          {
            "value": "正定县"
          },
          {
            "value": "行唐县"
          },
          {
            "value": "灵寿县"
          },
          {
            "value": "高邑县"
          },
          {
            "value": "深泽县"
          },
          {
            "value": "赞皇县"
          },
          {
            "value": "无极县"
          },
          {
            "value": "平山县"
          },
          {
            "value": "元氏县"
          },
          {
            "value": "赵县"
          },
          {
            "value": "辛集市"
          },
          {
            "value": "晋州市"
          },
          {
            "value": "新乐市"
          }
        ]
      },
      {
        "city": "唐山市",
		  "value": "唐山市",
		  "label": "唐山市",
        "children": [
          {
            "value": "路南区"
          },
          {
            "value": "路北区"
          },
          {
            "value": "古冶区"
          },
          {
            "value": "开平区"
          },
          {
            "value": "丰南区"
          },
          {
            "value": "丰润区"
          },
          {
            "value": "曹妃甸区"
          },
          {
            "value": "滦南县"
          },
          {
            "value": "乐亭县"
          },
          {
            "value": "迁西县"
          },
          {
            "value": "玉田县"
          },
          {
            "value": "遵化市"
          },
          {
            "value": "迁安市"
          },
          {
            "value": "滦州市"
          }
        ]
      },
      {
        "city": "秦皇岛市",
		  "value": "秦皇岛市",
		  "label": "秦皇岛市",
        "children": [
          {
            "value": "海港区"
          },
          {
            "value": "山海关区"
          },
          {
            "value": "北戴河区"
          },
          {
            "value": "抚宁区"
          },
          {
            "value": "青龙满族自治县"
          },
          {
            "value": "昌黎县"
          },
          {
            "value": "卢龙县"
          }
        ]
      },
      {
        "city": "邯郸市",
		  "value": "邯郸市",
		  "label": "邯郸市",
        "children": [
          {
            "value": "邯山区"
          },
          {
            "value": "丛台区"
          },
          {
            "value": "复兴区"
          },
          {
            "value": "峰峰矿区"
          },
          {
            "value": "肥乡区"
          },
          {
            "value": "永年区"
          },
          {
            "value": "临漳县"
          },
          {
            "value": "成安县"
          },
          {
            "value": "大名县"
          },
          {
            "value": "涉县"
          },
          {
            "value": "磁县"
          },
          {
            "value": "邱县"
          },
          {
            "value": "鸡泽县"
          },
          {
            "value": "广平县"
          },
          {
            "value": "馆陶县"
          },
          {
            "value": "魏县"
          },
          {
            "value": "曲周县"
          },
          {
            "value": "武安市"
          }
        ]
      },
      {
        "city": "邢台市",
		  "value": "邢台市",
		  "label": "邢台市",
        "children": [
          {
            "value": "襄都区"
          },
          {
            "value": "信都区"
          },
          {
            "value": "任泽区"
          },
          {
            "value": "南和区"
          },
          {
            "value": "临城县"
          },
          {
            "value": "内丘县"
          },
          {
            "value": "柏乡县"
          },
          {
            "value": "隆尧县"
          },
          {
            "value": "宁晋县"
          },
          {
            "value": "巨鹿县"
          },
          {
            "value": "新河县"
          },
          {
            "value": "广宗县"
          },
          {
            "value": "平乡县"
          },
          {
            "value": "威县"
          },
          {
            "value": "清河县"
          },
          {
            "value": "临西县"
          },
          {
            "value": "南宫市"
          },
          {
            "value": "沙河市"
          }
        ]
      },
      {
        "city": "保定市",
		  "value": "保定市",
		  "label": "保定市",
        "children": [
          {
            "value": "竞秀区"
          },
          {
            "value": "莲池区"
          },
          {
            "value": "满城区"
          },
          {
            "value": "清苑区"
          },
          {
            "value": "徐水区"
          },
          {
            "value": "涞水县"
          },
          {
            "value": "阜平县"
          },
          {
            "value": "定兴县"
          },
          {
            "value": "唐县"
          },
          {
            "value": "高阳县"
          },
          {
            "value": "容城县"
          },
          {
            "value": "涞源县"
          },
          {
            "value": "望都县"
          },
          {
            "value": "安新县"
          },
          {
            "value": "易县"
          },
          {
            "value": "曲阳县"
          },
          {
            "value": "蠡县"
          },
          {
            "value": "顺平县"
          },
          {
            "value": "博野县"
          },
          {
            "value": "雄县"
          },
          {
            "value": "涿州市"
          },
          {
            "value": "定州市"
          },
          {
            "value": "安国市"
          },
          {
            "value": "高碑店市"
          }
        ]
      },
      {
        "city": "张家口市",
		  "value": "张家口市",
		  "label": "张家口市",
        "children": [
          {
            "value": "桥东区"
          },
          {
            "value": "桥西区"
          },
          {
            "value": "宣化区"
          },
          {
            "value": "下花园区"
          },
          {
            "value": "万全区"
          },
          {
            "value": "崇礼区"
          },
          {
            "value": "张北县"
          },
          {
            "value": "康保县"
          },
          {
            "value": "沽源县"
          },
          {
            "value": "尚义县"
          },
          {
            "value": "蔚县"
          },
          {
            "value": "阳原县"
          },
          {
            "value": "怀安县"
          },
          {
            "value": "怀来县"
          },
          {
            "value": "涿鹿县"
          },
          {
            "value": "赤城县"
          }
        ]
      },
      {
        "city": "承德市",
		  "value": "承德市",
		  "label": "承德市",
        "children": [
          {
            "value": "双桥区"
          },
          {
            "value": "双滦区"
          },
          {
            "value": "鹰手营子矿区"
          },
          {
            "value": "承德县"
          },
          {
            "value": "兴隆县"
          },
          {
            "value": "滦平县"
          },
          {
            "value": "隆化县"
          },
          {
            "value": "丰宁满族自治县"
          },
          {
            "value": "宽城满族自治县"
          },
          {
            "value": "围场满族蒙古族自治县"
          },
          {
            "value": "平泉市"
          }
        ]
      },
      {
        "city": "沧州市",
		  "value": "沧州市",
		  "label": "沧州市",
        "children": [
          {
            "value": "新华区"
          },
          {
            "value": "运河区"
          },
          {
            "value": "沧县"
          },
          {
            "value": "青县"
          },
          {
            "value": "东光县"
          },
          {
            "value": "海兴县"
          },
          {
            "value": "盐山县"
          },
          {
            "value": "肃宁县"
          },
          {
            "value": "南皮县"
          },
          {
            "value": "吴桥县"
          },
          {
            "value": "献县"
          },
          {
            "value": "孟村回族自治县"
          },
          {
            "value": "泊头市"
          },
          {
            "value": "任丘市"
          },
          {
            "value": "黄骅市"
          },
          {
            "value": "河间市"
          }
        ]
      },
      {
        "city": "廊坊市",
		  "value": "廊坊市",
		  "label": "廊坊市",
        "children": [
          {
            "value": "安次区"
          },
          {
            "value": "广阳区"
          },
          {
            "value": "固安县"
          },
          {
            "value": "永清县"
          },
          {
            "value": "香河县"
          },
          {
            "value": "大城县"
          },
          {
            "value": "文安县"
          },
          {
            "value": "大厂回族自治县"
          },
          {
            "value": "霸州市"
          },
          {
            "value": "三河市"
          }
        ]
      },
      {
        "city": "衡水市",
		  "value": "衡水市",
		  "label": "衡水市",
        "children": [
          {
            "value": "桃城区"
          },
          {
            "value": "冀州区"
          },
          {
            "value": "枣强县"
          },
          {
            "value": "武邑县"
          },
          {
            "value": "武强县"
          },
          {
            "value": "饶阳县"
          },
          {
            "value": "安平县"
          },
          {
            "value": "故城县"
          },
          {
            "value": "景县"
          },
          {
            "value": "阜城县"
          },
          {
            "value": "深州市"
          }
        ]
      }
    ]
  },
  
  {
    "value": "山西省",
	 "label": "山西省",
    "children": [
      {
        "city": "太原市",
		  "value": "太原市",
		  "label": "太原市",
        "children": [
          {
            "value": "小店区"
          },
          {
            "value": "迎泽区"
          },
          {
            "value": "杏花岭区"
          },
          {
            "value": "尖草坪区"
          },
          {
            "value": "万柏林区"
          },
          {
            "value": "晋源区"
          },
          {
            "value": "清徐县"
          },
          {
            "value": "阳曲县"
          },
          {
            "value": "娄烦县"
          },
          {
            "value": "古交市"
          }
        ]
      },
      {
        "city": "大同市",
		  "value": "大同市",
		  "label": "大同市",
        "children": [
          {
            "value": "新荣区"
          },
          {
            "value": "平城区"
          },
          {
            "value": "云冈区"
          },
          {
            "value": "云州区"
          },
          {
            "value": "阳高县"
          },
          {
            "value": "天镇县"
          },
          {
            "value": "广灵县"
          },
          {
            "value": "灵丘县"
          },
          {
            "value": "浑源县"
          },
          {
            "value": "左云县"
          }
        ]
      },
      {
        "city": "阳泉市",
		  "value": "阳泉市",
		  "label": "阳泉市",
        "children": [
          {
            "value": "城区"
          },
          {
            "value": "矿区"
          },
          {
            "value": "郊区"
          },
          {
            "value": "平定县"
          },
          {
            "value": "盂县"
          }
        ]
      },
      {
        "city": "长治市",
		  "value": "长治市",
		  "label": "长治市",
        "children": [
          {
            "value": "潞州区"
          },
          {
            "value": "上党区"
          },
          {
            "value": "屯留区"
          },
          {
            "value": "潞城区"
          },
          {
            "value": "襄垣县"
          },
          {
            "value": "平顺县"
          },
          {
            "value": "黎城县"
          },
          {
            "value": "壶关县"
          },
          {
            "value": "长子县"
          },
          {
            "value": "武乡县"
          },
          {
            "value": "沁县"
          },
          {
            "value": "沁源县"
          }
        ]
      },
      {
        "city": "晋城市",
		  "value": "晋城市",
		  "label": "晋城市",
        "children": [
          {
            "value": "城区"
          },
          {
            "value": "沁水县"
          },
          {
            "value": "阳城县"
          },
          {
            "value": "陵川县"
          },
          {
            "value": "泽州县"
          },
          {
            "value": "高平市"
          }
        ]
      },
      {
        "city": "朔州市",
		  "value": "朔州市",
		  "label": "朔州市",
        "children": [
          {
            "value": "朔城区"
          },
          {
            "value": "平鲁区"
          },
          {
            "value": "山阴县"
          },
          {
            "value": "应县"
          },
          {
            "value": "右玉县"
          },
          {
            "value": "怀仁市"
          }
        ]
      },
      {
        "city": "晋中市",
		  "value": "晋中市",
		  "label": "晋中市",
        "children": [
          {
            "value": "榆次区"
          },
          {
            "value": "太谷区"
          },
          {
            "value": "榆社县"
          },
          {
            "value": "左权县"
          },
          {
            "value": "和顺县"
          },
          {
            "value": "昔阳县"
          },
          {
            "value": "寿阳县"
          },
          {
            "value": "祁县"
          },
          {
            "value": "平遥县"
          },
          {
            "value": "灵石县"
          },
          {
            "value": "介休市"
          }
        ]
      },
      {
        "city": "运城市",
		  "value": "运城市",
		  "label": "运城市",
        "children": [
          {
            "value": "盐湖区"
          },
          {
            "value": "临猗县"
          },
          {
            "value": "万荣县"
          },
          {
            "value": "闻喜县"
          },
          {
            "value": "稷山县"
          },
          {
            "value": "新绛县"
          },
          {
            "value": "绛县"
          },
          {
            "value": "垣曲县"
          },
          {
            "value": "夏县"
          },
          {
            "value": "平陆县"
          },
          {
            "value": "芮城县"
          },
          {
            "value": "永济市"
          },
          {
            "value": "河津市"
          }
        ]
      },
      {
        "city": "忻州市",
		  "value": "忻州市",
		  "label": "忻州市",
        "children": [
          {
            "value": "忻府区"
          },
          {
            "value": "定襄县"
          },
          {
            "value": "五台县"
          },
          {
            "value": "代县"
          },
          {
            "value": "繁峙县"
          },
          {
            "value": "宁武县"
          },
          {
            "value": "静乐县"
          },
          {
            "value": "神池县"
          },
          {
            "value": "五寨县"
          },
          {
            "value": "岢岚县"
          },
          {
            "value": "河曲县"
          },
          {
            "value": "保德县"
          },
          {
            "value": "偏关县"
          },
          {
            "value": "原平市"
          }
        ]
      },
      {
        "city": "临汾市",
		  "value": "临汾市",
		  "label": "临汾市",
        "children": [
          {
            "value": "尧都区"
          },
          {
            "value": "曲沃县"
          },
          {
            "value": "翼城县"
          },
          {
            "value": "襄汾县"
          },
          {
            "value": "洪洞县"
          },
          {
            "value": "古县"
          },
          {
            "value": "安泽县"
          },
          {
            "value": "浮山县"
          },
          {
            "value": "吉县"
          },
          {
            "value": "乡宁县"
          },
          {
            "value": "大宁县"
          },
          {
            "value": "隰县"
          },
          {
            "value": "永和县"
          },
          {
            "value": "蒲县"
          },
          {
            "value": "汾西县"
          },
          {
            "value": "侯马市"
          },
          {
            "value": "霍州市"
          }
        ]
      },
      {
        "city": "吕梁市",
		  "value": "吕梁市",
		  "label": "吕梁市",
        "children": [
          {
            "value": "离石区"
          },
          {
            "value": "文水县"
          },
          {
            "value": "交城县"
          },
          {
            "value": "兴县"
          },
          {
            "value": "临县"
          },
          {
            "value": "柳林县"
          },
          {
            "value": "石楼县"
          },
          {
            "value": "岚县"
          },
          {
            "value": "方山县"
          },
          {
            "value": "中阳县"
          },
          {
            "value": "交口县"
          },
          {
            "value": "孝义市"
          },
          {
            "value": "汾阳市"
          }
        ]
      }
    ]
  },
  
  {
    "value": "内蒙古自治区",
	 "label": "内蒙古自治区",
    "children": [
      {
        "city": "呼和浩特市",
		  "value": "呼和浩特市",
		  "label": "呼和浩特市",
        "children": [
          {
            "value": "新城区"
          },
          {
            "value": "回民区"
          },
          {
            "value": "玉泉区"
          },
          {
            "value": "赛罕区"
          },
          {
            "value": "土默特左旗"
          },
          {
            "value": "托克托县"
          },
          {
            "value": "和林格尔县"
          },
          {
            "value": "清水河县"
          },
          {
            "value": "武川县"
          }
        ]
      },
      {
        "city": "包头市",
		  "value": "包头市",
		  "label": "包头市",
        "children": [
          {
            "value": "东河区"
          },
          {
            "value": "昆都仑区"
          },
          {
            "value": "青山区"
          },
          {
            "value": "石拐区"
          },
          {
            "value": "白云鄂博矿区"
          },
          {
            "value": "九原区"
          },
          {
            "value": "土默特右旗"
          },
          {
            "value": "固阳县"
          },
          {
            "value": "达尔罕茂明安联合旗"
          }
        ]
      },
      {
        "city": "乌海市",
		  "value": "乌海市",
		  "label": "乌海市",
        "children": [
          {
            "value": "海勃湾区"
          },
          {
            "value": "海南区"
          },
          {
            "value": "乌达区"
          }
        ]
      },
      {
        "city": "赤峰市",
		  "value": "赤峰市",
		  "label": "赤峰市",
        "children": [
          {
            "value": "红山区"
          },
          {
            "value": "元宝山区"
          },
          {
            "value": "松山区"
          },
          {
            "value": "阿鲁科尔沁旗"
          },
          {
            "value": "巴林左旗"
          },
          {
            "value": "巴林右旗"
          },
          {
            "value": "林西县"
          },
          {
            "value": "克什克腾旗"
          },
          {
            "value": "翁牛特旗"
          },
          {
            "value": "喀喇沁旗"
          },
          {
            "value": "宁城县"
          },
          {
            "value": "敖汉旗"
          }
        ]
      },
      {
        "city": "通辽市",
		  "value": "通辽市",
		  "label": "通辽市",
        "children": [
          {
            "value": "科尔沁区"
          },
          {
            "value": "科尔沁左翼中旗"
          },
          {
            "value": "科尔沁左翼后旗"
          },
          {
            "value": "开鲁县"
          },
          {
            "value": "库伦旗"
          },
          {
            "value": "奈曼旗"
          },
          {
            "value": "扎鲁特旗"
          },
          {
            "value": "霍林郭勒市"
          }
        ]
      },
      {
        "city": "鄂尔多斯市",
		  "value": "鄂尔多斯市",
		  "label": "鄂尔多斯市",
        "children": [
          {
            "value": "东胜区"
          },
          {
            "value": "康巴什区"
          },
          {
            "value": "达拉特旗"
          },
          {
            "value": "准格尔旗"
          },
          {
            "value": "鄂托克前旗"
          },
          {
            "value": "鄂托克旗"
          },
          {
            "value": "杭锦旗"
          },
          {
            "value": "乌审旗"
          },
          {
            "value": "伊金霍洛旗"
          }
        ]
      },
      {
        "city": "呼伦贝尔市",
		  "value": "呼伦贝尔市",
		  "label": "呼伦贝尔市",
        "children": [
          {
            "value": "海拉尔区"
          },
          {
            "value": "扎赉诺尔区"
          },
          {
            "value": "阿荣旗"
          },
          {
            "value": "莫力达瓦达斡尔族自治旗"
          },
          {
            "value": "鄂伦春自治旗"
          },
          {
            "value": "鄂温克族自治旗"
          },
          {
            "value": "陈巴尔虎旗"
          },
          {
            "value": "新巴尔虎左旗"
          },
          {
            "value": "新巴尔虎右旗"
          },
          {
            "value": "满洲里市"
          },
          {
            "value": "牙克石市"
          },
          {
            "value": "扎兰屯市"
          },
          {
            "value": "额尔古纳市"
          },
          {
            "value": "根河市"
          }
        ]
      },
      {
        "city": "巴彦淖尔市",
		  "value": "巴彦淖尔市",
		  "label": "巴彦淖尔市",
        "children": [
          {
            "value": "临河区"
          },
          {
            "value": "五原县"
          },
          {
            "value": "磴口县"
          },
          {
            "value": "乌拉特前旗"
          },
          {
            "value": "乌拉特中旗"
          },
          {
            "value": "乌拉特后旗"
          },
          {
            "value": "杭锦后旗"
          }
        ]
      },
      {
        "city": "乌兰察布市",
		  "value": "乌兰察布市",
		  "label": "乌兰察布市",
        "children": [
          {
            "value": "集宁区"
          },
          {
            "value": "卓资县"
          },
          {
            "value": "化德县"
          },
          {
            "value": "商都县"
          },
          {
            "value": "兴和县"
          },
          {
            "value": "凉城县"
          },
          {
            "value": "察哈尔右翼前旗"
          },
          {
            "value": "察哈尔右翼中旗"
          },
          {
            "value": "察哈尔右翼后旗"
          },
          {
            "value": "四子王旗"
          },
          {
            "value": "丰镇市"
          }
        ]
      },
      {
        "city": "兴安盟",
		  "value": "兴安盟",
		  "label": "兴安盟",
        "children": [
          {
            "value": "乌兰浩特市"
          },
          {
            "value": "阿尔山市"
          },
          {
            "value": "科尔沁右翼前旗"
          },
          {
            "value": "科尔沁右翼中旗"
          },
          {
            "value": "扎赉特旗"
          },
          {
            "value": "突泉县"
          }
        ]
      },
      {
        "city": "锡林郭勒盟",
		  "value": "锡林郭勒盟",
		  "label": "锡林郭勒盟",
        "children": [
          {
            "value": "二连浩特市"
          },
          {
            "value": "锡林浩特市"
          },
          {
            "value": "阿巴嘎旗"
          },
          {
            "value": "苏尼特左旗"
          },
          {
            "value": "苏尼特右旗"
          },
          {
            "value": "东乌珠穆沁旗"
          },
          {
            "value": "西乌珠穆沁旗"
          },
          {
            "value": "太仆寺旗"
          },
          {
            "value": "镶黄旗"
          },
          {
            "value": "正镶白旗"
          },
          {
            "value": "正蓝旗"
          },
          {
            "value": "多伦县"
          }
        ]
      },
      {
        "city": "阿拉善盟",
		  "value": "阿拉善盟",
		  "label": "阿拉善盟",
        "children": [
          {
            "value": "阿拉善左旗"
          },
          {
            "value": "阿拉善右旗"
          },
          {
            "value": "额济纳旗"
          }
        ]
      }
    ]
  },
  
  {
    "value": "辽宁省",
	 "label": "辽宁省",
    "children": [
      {
        "city": "沈阳市",
		  "value": "沈阳市",
		  "label": "沈阳市",
        "children": [
          {
            "value": "和平区"
          },
          {
            "value": "沈河区"
          },
          {
            "value": "大东区"
          },
          {
            "value": "皇姑区"
          },
          {
            "value": "铁西区"
          },
          {
            "value": "苏家屯区"
          },
          {
            "value": "浑南区"
          },
          {
            "value": "沈北新区"
          },
          {
            "value": "于洪区"
          },
          {
            "value": "辽中区"
          },
          {
            "value": "康平县"
          },
          {
            "value": "法库县"
          },
          {
            "value": "新民市"
          }
        ]
      },
      {
        "city": "大连市",
		  "value": "大连市",
		  "label": "大连市",
        "children": [
          {
            "value": "中山区"
          },
          {
            "value": "西岗区"
          },
          {
            "value": "沙河口区"
          },
          {
            "value": "甘井子区"
          },
          {
            "value": "旅顺口区"
          },
          {
            "value": "金州区"
          },
          {
            "value": "普兰店区"
          },
          {
            "value": "长海县"
          },
          {
            "value": "瓦房店市"
          },
          {
            "value": "庄河市"
          }
        ]
      },
      {
        "city": "鞍山市",
		  "value": "鞍山市",
		  "label": "鞍山市",
        "children": [
          {
            "value": "铁东区"
          },
          {
            "value": "铁西区"
          },
          {
            "value": "立山区"
          },
          {
            "value": "千山区"
          },
          {
            "value": "台安县"
          },
          {
            "value": "岫岩满族自治县"
          },
          {
            "value": "海城市"
          }
        ]
      },
      {
        "city": "抚顺市",
		  "value": "抚顺市",
		  "label": "抚顺市",
        "children": [
          {
            "value": "新抚区"
          },
          {
            "value": "东洲区"
          },
          {
            "value": "望花区"
          },
          {
            "value": "顺城区"
          },
          {
            "value": "抚顺县"
          },
          {
            "value": "新宾满族自治县"
          },
          {
            "value": "清原满族自治县"
          }
        ]
      },
      {
        "city": "本溪市",
		  "value": "本溪市",
		  "label": "本溪市",
        "children": [
          {
            "value": "平山区"
          },
          {
            "value": "溪湖区"
          },
          {
            "value": "明山区"
          },
          {
            "value": "南芬区"
          },
          {
            "value": "本溪满族自治县"
          },
          {
            "value": "桓仁满族自治县"
          }
        ]
      },
      {
        "city": "丹东市",
		  "value": "丹东市",
		  "label": "丹东市",
        "children": [
          {
            "value": "元宝区"
          },
          {
            "value": "振兴区"
          },
          {
            "value": "振安区"
          },
          {
            "value": "宽甸满族自治县"
          },
          {
            "value": "东港市"
          },
          {
            "value": "凤城市"
          }
        ]
      },
      {
        "city": "锦州市",
		  "value": "锦州市",
		  "label": "锦州市",
        "children": [
          {
            "value": "古塔区"
          },
          {
            "value": "凌河区"
          },
          {
            "value": "太和区"
          },
          {
            "value": "黑山县"
          },
          {
            "value": "义县"
          },
          {
            "value": "凌海市"
          },
          {
            "value": "北镇市"
          }
        ]
      },
      {
        "city": "营口市",
		  "value": "营口市",
		  "label": "营口市",
        "children": [
          {
            "value": "站前区"
          },
          {
            "value": "西市区"
          },
          {
            "value": "鲅鱼圈区"
          },
          {
            "value": "老边区"
          },
          {
            "value": "盖州市"
          },
          {
            "value": "大石桥市"
          }
        ]
      },
      {
        "city": "阜新市",
		  "value": "阜新市",
		  "label": "阜新市",
        "children": [
          {
            "value": "海州区"
          },
          {
            "value": "新邱区"
          },
          {
            "value": "太平区"
          },
          {
            "value": "清河门区"
          },
          {
            "value": "细河区"
          },
          {
            "value": "阜新蒙古族自治县"
          },
          {
            "value": "彰武县"
          }
        ]
      },
      {
        "city": "辽阳市",
		  "value": "辽阳市",
		  "label": "辽阳市",
        "children": [
          {
            "value": "白塔区"
          },
          {
            "value": "文圣区"
          },
          {
            "value": "宏伟区"
          },
          {
            "value": "弓长岭区"
          },
          {
            "value": "太子河区"
          },
          {
            "value": "辽阳县"
          },
          {
            "value": "灯塔市"
          }
        ]
      },
      {
        "city": "盘锦市",
		  "value": "盘锦市",
		  "label": "盘锦市",
        "children": [
          {
            "value": "双台子区"
          },
          {
            "value": "兴隆台区"
          },
          {
            "value": "大洼区"
          },
          {
            "value": "盘山县"
          }
        ]
      },
      {
        "city": "铁岭市",
		  "value": "铁岭市",
		  "label": "铁岭市",
        "children": [
          {
            "value": "银州区"
          },
          {
            "value": "清河区"
          },
          {
            "value": "铁岭县"
          },
          {
            "value": "西丰县"
          },
          {
            "value": "昌图县"
          },
          {
            "value": "调兵山市"
          },
          {
            "value": "开原市"
          }
        ]
      },
      {
        "city": "朝阳市",
		  "value": "朝阳市",
		  "label": "朝阳市",
        "children": [
          {
            "value": "双塔区"
          },
          {
            "value": "龙城区"
          },
          {
            "value": "朝阳县"
          },
          {
            "value": "建平县"
          },
          {
            "value": "喀喇沁左翼蒙古族自治县"
          },
          {
            "value": "北票市"
          },
          {
            "value": "凌源市"
          }
        ]
      },
      {
        "city": "葫芦岛市",
		  "value": "葫芦岛市",
		  "label": "葫芦岛市",
        "children": [
          {
            "value": "连山区"
          },
          {
            "value": "龙港区"
          },
          {
            "value": "南票区"
          },
          {
            "value": "绥中县"
          },
          {
            "value": "建昌县"
          },
          {
            "value": "兴城市"
          }
        ]
      }
    ]
  },
  
  {
    "value": "吉林省",
	 "label": "吉林省",
    "children": [
      {
        "city": "长春市",
		  "value": "长春市",
		  "label": "长春市",
        "children": [
          {
            "value": "南关区"
          },
          {
            "value": "宽城区"
          },
          {
            "value": "朝阳区"
          },
          {
            "value": "二道区"
          },
          {
            "value": "绿园区"
          },
          {
            "value": "双阳区"
          },
          {
            "value": "九台区"
          },
          {
            "value": "农安县"
          },
          {
            "value": "榆树市"
          },
          {
            "value": "德惠市"
          },
          {
            "value": "公主岭市"
          }
        ]
      },
      {
        "city": "吉林市",
		  "value": "吉林市",
		  "label": "吉林市",
        "children": [
          {
            "value": "昌邑区"
          },
          {
            "value": "龙潭区"
          },
          {
            "value": "船营区"
          },
          {
            "value": "丰满区"
          },
          {
            "value": "永吉县"
          },
          {
            "value": "蛟河市"
          },
          {
            "value": "桦甸市"
          },
          {
            "value": "舒兰市"
          },
          {
            "value": "磐石市"
          }
        ]
      },
      {
        "city": "四平市",
		  "value": "四平市",
		  "label": "四平市",
        "children": [
          {
            "value": "铁西区"
          },
          {
            "value": "铁东区"
          },
          {
            "value": "梨树县"
          },
          {
            "value": "伊通满族自治县"
          },
          {
            "value": "双辽市"
          }
        ]
      },
      {
        "city": "辽源市",
		  "value": "辽源市",
		  "label": "辽源市",
        "children": [
          {
            "value": "龙山区"
          },
          {
            "value": "西安区"
          },
          {
            "value": "东丰县"
          },
          {
            "value": "东辽县"
          }
        ]
      },
      {
        "city": "通化市",
		  "value": "通化市",
		  "label": "通化市",
        "children": [
          {
            "value": "东昌区"
          },
          {
            "value": "二道江区"
          },
          {
            "value": "通化县"
          },
          {
            "value": "辉南县"
          },
          {
            "value": "柳河县"
          },
          {
            "value": "梅河口市"
          },
          {
            "value": "集安市"
          }
        ]
      },
      {
        "city": "白山市",
		  "value": "白山市",
		  "label": "白山市",
        "children": [
          {
            "value": "浑江区"
          },
          {
            "value": "江源区"
          },
          {
            "value": "抚松县"
          },
          {
            "value": "靖宇县"
          },
          {
            "value": "长白朝鲜族自治县"
          },
          {
            "value": "临江市"
          }
        ]
      },
      {
        "city": "松原市",
		  "value": "松原市",
		  "label": "松原市",
        "children": [
          {
            "value": "宁江区"
          },
          {
            "value": "前郭尔罗斯蒙古族自治县"
          },
          {
            "value": "长岭县"
          },
          {
            "value": "乾安县"
          },
          {
            "value": "扶余市"
          }
        ]
      },
      {
        "city": "白城市",
		  "value": "白城市",
		  "label": "白城市",
        "children": [
          {
            "value": "洮北区"
          },
          {
            "value": "镇赉县"
          },
          {
            "value": "通榆县"
          },
          {
            "value": "洮南市"
          },
          {
            "value": "大安市"
          }
        ]
      },
      {
        "city": "延边朝鲜族自治州",
		  "value": "延边朝鲜族自治州",
		  "label": "延边朝鲜族自治州",
        "children": [
          {
            "value": "延吉市"
          },
          {
            "value": "图们市"
          },
          {
            "value": "敦化市"
          },
          {
            "value": "珲春市"
          },
          {
            "value": "龙井市"
          },
          {
            "value": "和龙市"
          },
          {
            "value": "汪清县"
          },
          {
            "value": "安图县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "黑龙江省",
	 "label": "黑龙江省",
    "children": [
      {
        "city": "哈尔滨市",
		  "value": "哈尔滨市",
		  "label": "哈尔滨市",
        "children": [
          {
            "value": "道里区"
          },
          {
            "value": "南岗区"
          },
          {
            "value": "道外区"
          },
          {
            "value": "平房区"
          },
          {
            "value": "松北区"
          },
          {
            "value": "香坊区"
          },
          {
            "value": "呼兰区"
          },
          {
            "value": "阿城区"
          },
          {
            "value": "双城区"
          },
          {
            "value": "依兰县"
          },
          {
            "value": "方正县"
          },
          {
            "value": "宾县"
          },
          {
            "value": "巴彦县"
          },
          {
            "value": "木兰县"
          },
          {
            "value": "通河县"
          },
          {
            "value": "延寿县"
          },
          {
            "value": "尚志市"
          },
          {
            "value": "五常市"
          }
        ]
      },
      {
        "city": "齐齐哈尔市",
		  "value": "齐齐哈尔市",
		  "label": "齐齐哈尔市",
        "children": [
          {
            "value": "龙沙区"
          },
          {
            "value": "建华区"
          },
          {
            "value": "铁锋区"
          },
          {
            "value": "昂昂溪区"
          },
          {
            "value": "富拉尔基区"
          },
          {
            "value": "碾子山区"
          },
          {
            "value": "梅里斯达斡尔族区"
          },
          {
            "value": "龙江县"
          },
          {
            "value": "依安县"
          },
          {
            "value": "泰来县"
          },
          {
            "value": "甘南县"
          },
          {
            "value": "富裕县"
          },
          {
            "value": "克山县"
          },
          {
            "value": "克东县"
          },
          {
            "value": "拜泉县"
          },
          {
            "value": "讷河市"
          }
        ]
      },
      {
        "city": "鸡西市",
		  "value": "鸡西市",
		  "label": "鸡西市",
        "children": [
          {
            "value": "鸡冠区"
          },
          {
            "value": "恒山区"
          },
          {
            "value": "滴道区"
          },
          {
            "value": "梨树区"
          },
          {
            "value": "城子河区"
          },
          {
            "value": "麻山区"
          },
          {
            "value": "鸡东县"
          },
          {
            "value": "虎林市"
          },
          {
            "value": "密山市"
          }
        ]
      },
      {
        "city": "鹤岗市",
		  "value": "鹤岗市",
		  "label": "鹤岗市",
        "children": [
          {
            "value": "向阳区"
          },
          {
            "value": "工农区"
          },
          {
            "value": "南山区"
          },
          {
            "value": "兴安区"
          },
          {
            "value": "东山区"
          },
          {
            "value": "兴山区"
          },
          {
            "value": "萝北县"
          },
          {
            "value": "绥滨县"
          }
        ]
      },
      {
        "city": "双鸭山市",
		  "value": "双鸭山市",
		  "label": "双鸭山市",
        "children": [
          {
            "value": "尖山区"
          },
          {
            "value": "岭东区"
          },
          {
            "value": "四方台区"
          },
          {
            "value": "宝山区"
          },
          {
            "value": "集贤县"
          },
          {
            "value": "友谊县"
          },
          {
            "value": "宝清县"
          },
          {
            "value": "饶河县"
          }
        ]
      },
      {
        "city": "大庆市",
		  "value": "大庆市",
		  "label": "大庆市",
        "children": [
          {
            "value": "萨尔图区"
          },
          {
            "value": "龙凤区"
          },
          {
            "value": "让胡路区"
          },
          {
            "value": "红岗区"
          },
          {
            "value": "大同区"
          },
          {
            "value": "肇州县"
          },
          {
            "value": "肇源县"
          },
          {
            "value": "林甸县"
          },
          {
            "value": "杜尔伯特蒙古族自治县"
          }
        ]
      },
      {
        "city": "伊春市",
		  "value": "伊春市",
		  "label": "伊春市",
        "children": [
          {
            "value": "伊美区"
          },
          {
            "value": "乌翠区"
          },
          {
            "value": "友好区"
          },
          {
            "value": "嘉荫县"
          },
          {
            "value": "汤旺县"
          },
          {
            "value": "丰林县"
          },
          {
            "value": "大箐山县"
          },
          {
            "value": "南岔县"
          },
          {
            "value": "金林区"
          },
          {
            "value": "铁力市"
          }
        ]
      },
      {
        "city": "佳木斯市",
		  "value": "佳木斯市",
		  "label": "佳木斯市",
        "children": [
          {
            "value": "向阳区"
          },
          {
            "value": "前进区"
          },
          {
            "value": "东风区"
          },
          {
            "value": "郊区"
          },
          {
            "value": "桦南县"
          },
          {
            "value": "桦川县"
          },
          {
            "value": "汤原县"
          },
          {
            "value": "同江市"
          },
          {
            "value": "富锦市"
          },
          {
            "value": "抚远市"
          }
        ]
      },
      {
        "city": "七台河市",
		  "value": "七台河市",
		  "label": "七台河市",
        "children": [
          {
            "value": "新兴区"
          },
          {
            "value": "桃山区"
          },
          {
            "value": "茄子河区"
          },
          {
            "value": "勃利县"
          }
        ]
      },
      {
        "city": "牡丹江市",
		  "value": "牡丹江市",
		  "label": "牡丹江市",
        "children": [
          {
            "value": "东安区"
          },
          {
            "value": "阳明区"
          },
          {
            "value": "爱民区"
          },
          {
            "value": "西安区"
          },
          {
            "value": "林口县"
          },
          {
            "value": "绥芬河市"
          },
          {
            "value": "海林市"
          },
          {
            "value": "宁安市"
          },
          {
            "value": "穆棱市"
          },
          {
            "value": "东宁市"
          }
        ]
      },
      {
        "city": "黑河市",
		  "value": "黑河市",
		  "label": "黑河市",
        "children": [
          {
            "value": "爱辉区"
          },
          {
            "value": "逊克县"
          },
          {
            "value": "孙吴县"
          },
          {
            "value": "北安市"
          },
          {
            "value": "五大连池市"
          },
          {
            "value": "嫩江市"
          }
        ]
      },
      {
        "city": "绥化市",
		  "value": "绥化市",
		  "label": "绥化市",
        "children": [
          {
            "value": "北林区"
          },
          {
            "value": "望奎县"
          },
          {
            "value": "兰西县"
          },
          {
            "value": "青冈县"
          },
          {
            "value": "庆安县"
          },
          {
            "value": "明水县"
          },
          {
            "value": "绥棱县"
          },
          {
            "value": "安达市"
          },
          {
            "value": "肇东市"
          },
          {
            "value": "海伦市"
          }
        ]
      },
      {
        "city": "大兴安岭地区",
		  "value": "大兴安岭地区",
		  "label": "大兴安岭地区",
        "children": [
          {
            "value": "漠河市"
          },
          {
            "value": "呼玛县"
          },
          {
            "value": "塔河县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "上海市",
	 "label": "上海市",
    "children": [
      {
        "city": "上海市",
		  "value": "上海市",
		  "label": "上海市",
        "children": [
          {
            "value": "黄浦区"
          },
          {
            "value": "徐汇区"
          },
          {
            "value": "长宁区"
          },
          {
            "value": "静安区"
          },
          {
            "value": "普陀区"
          },
          {
            "value": "虹口区"
          },
          {
            "value": "杨浦区"
          },
          {
            "value": "闵行区"
          },
          {
            "value": "宝山区"
          },
          {
            "value": "嘉定区"
          },
          {
            "value": "浦东新区"
          },
          {
            "value": "金山区"
          },
          {
            "value": "松江区"
          },
          {
            "value": "青浦区"
          },
          {
            "value": "奉贤区"
          },
          {
            "value": "崇明区"
          }
        ]
      }
    ]
  },
  
  {
    "value": "江苏省",
	 "label": "江苏省",
    "children": [
      {
        "city": "南京市",
		  "value": "南京市",
		  "label": "南京市",
        "children": [
          {
            "value": "玄武区"
          },
          {
            "value": "秦淮区"
          },
          {
            "value": "建邺区"
          },
          {
            "value": "鼓楼区"
          },
          {
            "value": "浦口区"
          },
          {
            "value": "栖霞区"
          },
          {
            "value": "雨花台区"
          },
          {
            "value": "江宁区"
          },
          {
            "value": "六合区"
          },
          {
            "value": "溧水区"
          },
          {
            "value": "高淳区"
          }
        ]
      },
      {
        "city": "无锡市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "锡山区"
          },
          {
            "value": "惠山区"
          },
          {
            "value": "滨湖区"
          },
          {
            "value": "梁溪区"
          },
          {
            "value": "新吴区"
          },
          {
            "value": "江阴市"
          },
          {
            "value": "宜兴市"
          }
        ]
      },
      {
        "city": "徐州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "鼓楼区"
          },
          {
            "value": "云龙区"
          },
          {
            "value": "贾汪区"
          },
          {
            "value": "泉山区"
          },
          {
            "value": "铜山区"
          },
          {
            "value": "丰县"
          },
          {
            "value": "沛县"
          },
          {
            "value": "睢宁县"
          },
          {
            "value": "新沂市"
          },
          {
            "value": "邳州市"
          }
        ]
      },
      {
        "city": "常州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "天宁区"
          },
          {
            "value": "钟楼区"
          },
          {
            "value": "新北区"
          },
          {
            "value": "武进区"
          },
          {
            "value": "金坛区"
          },
          {
            "value": "溧阳市"
          }
        ]
      },
      {
        "city": "苏州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "虎丘区"
          },
          {
            "value": "吴中区"
          },
          {
            "value": "相城区"
          },
          {
            "value": "姑苏区"
          },
          {
            "value": "吴江区"
          },
          {
            "value": "常熟市"
          },
          {
            "value": "张家港市"
          },
          {
            "value": "昆山市"
          },
          {
            "value": "太仓市"
          }
        ]
      },
      {
        "city": "南通市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "通州区"
          },
          {
            "value": "崇川区"
          },
          {
            "value": "海门区"
          },
          {
            "value": "如东县"
          },
          {
            "value": "启东市"
          },
          {
            "value": "如皋市"
          },
          {
            "value": "海安市"
          }
        ]
      },
      {
        "city": "连云港市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "连云区"
          },
          {
            "value": "海州区"
          },
          {
            "value": "赣榆区"
          },
          {
            "value": "东海县"
          },
          {
            "value": "灌云县"
          },
          {
            "value": "灌南县"
          }
        ]
      },
      {
        "city": "淮安市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "淮安区"
          },
          {
            "value": "淮阴区"
          },
          {
            "value": "清江浦区"
          },
          {
            "value": "洪泽区"
          },
          {
            "value": "涟水县"
          },
          {
            "value": "盱眙县"
          },
          {
            "value": "金湖县"
          }
        ]
      },
      {
        "city": "盐城市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "亭湖区"
          },
          {
            "value": "盐都区"
          },
          {
            "value": "大丰区"
          },
          {
            "value": "响水县"
          },
          {
            "value": "滨海县"
          },
          {
            "value": "阜宁县"
          },
          {
            "value": "射阳县"
          },
          {
            "value": "建湖县"
          },
          {
            "value": "东台市"
          }
        ]
      },
      {
        "city": "扬州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "广陵区"
          },
          {
            "value": "邗江区"
          },
          {
            "value": "江都区"
          },
          {
            "value": "宝应县"
          },
          {
            "value": "仪征市"
          },
          {
            "value": "高邮市"
          }
        ]
      },
      {
        "city": "镇江市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "京口区"
          },
          {
            "value": "润州区"
          },
          {
            "value": "丹徒区"
          },
          {
            "value": "丹阳市"
          },
          {
            "value": "扬中市"
          },
          {
            "value": "句容市"
          }
        ]
      },
      {
        "city": "泰州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "海陵区"
          },
          {
            "value": "高港区"
          },
          {
            "value": "姜堰区"
          },
          {
            "value": "兴化市"
          },
          {
            "value": "靖江市"
          },
          {
            "value": "泰兴市"
          }
        ]
      },
      {
        "city": "宿迁市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "宿城区"
          },
          {
            "value": "宿豫区"
          },
          {
            "value": "沭阳县"
          },
          {
            "value": "泗阳县"
          },
          {
            "value": "泗洪县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "浙江省",
	 "label": "浙江省",
    "children": [
      {
        "city": "杭州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "上城区"
          },
          {
            "value": "拱墅区"
          },
          {
            "value": "西湖区"
          },
          {
            "value": "滨江区"
          },
          {
            "value": "萧山区"
          },
          {
            "value": "余杭区"
          },
          {
            "value": "富阳区"
          },
          {
            "value": "临安区"
          },
          {
            "value": "临平区"
          },
          {
            "value": "钱塘区"
          },
          {
            "value": "桐庐县"
          },
          {
            "value": "淳安县"
          },
          {
            "value": "建德市"
          }
        ]
      },
      {
        "city": "宁波市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "海曙区"
          },
          {
            "value": "江北区"
          },
          {
            "value": "北仑区"
          },
          {
            "value": "镇海区"
          },
          {
            "value": "鄞州区"
          },
          {
            "value": "奉化区"
          },
          {
            "value": "象山县"
          },
          {
            "value": "宁海县"
          },
          {
            "value": "余姚市"
          },
          {
            "value": "慈溪市"
          }
        ]
      },
      {
        "city": "温州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "鹿城区"
          },
          {
            "value": "龙湾区"
          },
          {
            "value": "瓯海区"
          },
          {
            "value": "洞头区"
          },
          {
            "value": "永嘉县"
          },
          {
            "value": "平阳县"
          },
          {
            "value": "苍南县"
          },
          {
            "value": "文成县"
          },
          {
            "value": "泰顺县"
          },
          {
            "value": "瑞安市"
          },
          {
            "value": "乐清市"
          },
          {
            "value": "龙港市"
          }
        ]
      },
      {
        "city": "嘉兴市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "南湖区"
          },
          {
            "value": "秀洲区"
          },
          {
            "value": "嘉善县"
          },
          {
            "value": "海盐县"
          },
          {
            "value": "海宁市"
          },
          {
            "value": "平湖市"
          },
          {
            "value": "桐乡市"
          }
        ]
      },
      {
        "city": "湖州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "吴兴区"
          },
          {
            "value": "南浔区"
          },
          {
            "value": "德清县"
          },
          {
            "value": "长兴县"
          },
          {
            "value": "安吉县"
          }
        ]
      },
      {
        "city": "绍兴市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "越城区"
          },
          {
            "value": "柯桥区"
          },
          {
            "value": "上虞区"
          },
          {
            "value": "新昌县"
          },
          {
            "value": "诸暨市"
          },
          {
            "value": "嵊州市"
          }
        ]
      },
      {
        "city": "金华市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "婺城区"
          },
          {
            "value": "金东区"
          },
          {
            "value": "武义县"
          },
          {
            "value": "浦江县"
          },
          {
            "value": "磐安县"
          },
          {
            "value": "兰溪市"
          },
          {
            "value": "义乌市"
          },
          {
            "value": "东阳市"
          },
          {
            "value": "永康市"
          }
        ]
      },
      {
        "city": "衢州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "柯城区"
          },
          {
            "value": "衢江区"
          },
          {
            "value": "常山县"
          },
          {
            "value": "开化县"
          },
          {
            "value": "龙游县"
          },
          {
            "value": "江山市"
          }
        ]
      },
      {
        "city": "舟山市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "定海区"
          },
          {
            "value": "普陀区"
          },
          {
            "value": "岱山县"
          },
          {
            "value": "嵊泗县"
          }
        ]
      },
      {
        "city": "台州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "椒江区"
          },
          {
            "value": "黄岩区"
          },
          {
            "value": "路桥区"
          },
          {
            "value": "三门县"
          },
          {
            "value": "天台县"
          },
          {
            "value": "仙居县"
          },
          {
            "value": "温岭市"
          },
          {
            "value": "临海市"
          },
          {
            "value": "玉环市"
          }
        ]
      },
      {
        "city": "丽水市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "莲都区"
          },
          {
            "value": "青田县"
          },
          {
            "value": "缙云县"
          },
          {
            "value": "遂昌县"
          },
          {
            "value": "松阳县"
          },
          {
            "value": "云和县"
          },
          {
            "value": "庆元县"
          },
          {
            "value": "景宁畲族自治县"
          },
          {
            "value": "龙泉市"
          }
        ]
      }
    ]
  },
  
  {
    "value": "安徽省",
	 "label": "安徽省",
    "children": [
      {
        "city": "合肥市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "瑶海区"
          },
          {
            "value": "庐阳区"
          },
          {
            "value": "蜀山区"
          },
          {
            "value": "包河区"
          },
          {
            "value": "长丰县"
          },
          {
            "value": "肥东县"
          },
          {
            "value": "肥西县"
          },
          {
            "value": "庐江县"
          },
          {
            "value": "巢湖市"
          }
        ]
      },
      {
        "city": "芜湖市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "镜湖区"
          },
          {
            "value": "鸠江区"
          },
          {
            "value": "弋江区"
          },
          {
            "value": "湾沚区"
          },
          {
            "value": "繁昌区"
          },
          {
            "value": "南陵县"
          },
          {
            "value": "无为市"
          }
        ]
      },
      {
        "city": "蚌埠市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "龙子湖区"
          },
          {
            "value": "蚌山区"
          },
          {
            "value": "禹会区"
          },
          {
            "value": "淮上区"
          },
          {
            "value": "怀远县"
          },
          {
            "value": "五河县"
          },
          {
            "value": "固镇县"
          }
        ]
      },
      {
        "city": "淮南市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "大通区"
          },
          {
            "value": "田家庵区"
          },
          {
            "value": "谢家集区"
          },
          {
            "value": "八公山区"
          },
          {
            "value": "潘集区"
          },
          {
            "value": "凤台县"
          },
          {
            "value": "寿县"
          }
        ]
      },
      {
        "city": "马鞍山市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "花山区"
          },
          {
            "value": "雨山区"
          },
          {
            "value": "博望区"
          },
          {
            "value": "当涂县"
          },
          {
            "value": "含山县"
          },
          {
            "value": "和县"
          }
        ]
      },
      {
        "city": "淮北市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "杜集区"
          },
          {
            "value": "相山区"
          },
          {
            "value": "烈山区"
          },
          {
            "value": "濉溪县"
          }
        ]
      },
      {
        "city": "铜陵市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "铜官区"
          },
          {
            "value": "义安区"
          },
          {
            "value": "郊区"
          },
          {
            "value": "枞阳县"
          }
        ]
      },
      {
        "city": "安庆市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "迎江区"
          },
          {
            "value": "大观区"
          },
          {
            "value": "宜秀区"
          },
          {
            "value": "怀宁县"
          },
          {
            "value": "太湖县"
          },
          {
            "value": "宿松县"
          },
          {
            "value": "望江县"
          },
          {
            "value": "岳西县"
          },
          {
            "value": "桐城市"
          },
          {
            "value": "潜山市"
          }
        ]
      },
      {
        "city": "黄山市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "屯溪区"
          },
          {
            "value": "黄山区"
          },
          {
            "value": "徽州区"
          },
          {
            "value": "歙县"
          },
          {
            "value": "休宁县"
          },
          {
            "value": "黟县"
          },
          {
            "value": "祁门县"
          }
        ]
      },
      {
        "city": "滁州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "琅琊区"
          },
          {
            "value": "南谯区"
          },
          {
            "value": "来安县"
          },
          {
            "value": "全椒县"
          },
          {
            "value": "定远县"
          },
          {
            "value": "凤阳县"
          },
          {
            "value": "天长市"
          },
          {
            "value": "明光市"
          }
        ]
      },
      {
        "city": "阜阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "颍州区"
          },
          {
            "value": "颍东区"
          },
          {
            "value": "颍泉区"
          },
          {
            "value": "临泉县"
          },
          {
            "value": "太和县"
          },
          {
            "value": "阜南县"
          },
          {
            "value": "颍上县"
          },
          {
            "value": "界首市"
          }
        ]
      },
      {
        "city": "宿州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "埇桥区"
          },
          {
            "value": "砀山县"
          },
          {
            "value": "萧县"
          },
          {
            "value": "灵璧县"
          },
          {
            "value": "泗县"
          }
        ]
      },
      {
        "city": "六安市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "金安区"
          },
          {
            "value": "裕安区"
          },
          {
            "value": "叶集区"
          },
          {
            "value": "霍邱县"
          },
          {
            "value": "舒城县"
          },
          {
            "value": "金寨县"
          },
          {
            "value": "霍山县"
          }
        ]
      },
      {
        "city": "亳州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "谯城区"
          },
          {
            "value": "涡阳县"
          },
          {
            "value": "蒙城县"
          },
          {
            "value": "利辛县"
          }
        ]
      },
      {
        "city": "池州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "贵池区"
          },
          {
            "value": "东至县"
          },
          {
            "value": "石台县"
          },
          {
            "value": "青阳县"
          }
        ]
      },
      {
        "city": "宣城市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "宣州区"
          },
          {
            "value": "郎溪县"
          },
          {
            "value": "泾县"
          },
          {
            "value": "绩溪县"
          },
          {
            "value": "旌德县"
          },
          {
            "value": "宁国市"
          },
          {
            "value": "广德市"
          }
        ]
      }
    ]
  },
  
  {
    "value": "福建省",
	 "label": "福建省",
    "children": [
      {
        "city": "福州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "鼓楼区"
          },
          {
            "value": "台江区"
          },
          {
            "value": "仓山区"
          },
          {
            "value": "马尾区"
          },
          {
            "value": "晋安区"
          },
          {
            "value": "长乐区"
          },
          {
            "value": "闽侯县"
          },
          {
            "value": "连江县"
          },
          {
            "value": "罗源县"
          },
          {
            "value": "闽清县"
          },
          {
            "value": "永泰县"
          },
          {
            "value": "平潭县"
          },
          {
            "value": "福清市"
          }
        ]
      },
      {
        "city": "厦门市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "思明区"
          },
          {
            "value": "海沧区"
          },
          {
            "value": "湖里区"
          },
          {
            "value": "集美区"
          },
          {
            "value": "同安区"
          },
          {
            "value": "翔安区"
          }
        ]
      },
      {
        "city": "莆田市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "城厢区"
          },
          {
            "value": "涵江区"
          },
          {
            "value": "荔城区"
          },
          {
            "value": "秀屿区"
          },
          {
            "value": "仙游县"
          }
        ]
      },
      {
        "city": "三明市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "三元区"
          },
          {
            "value": "沙县区"
          },
          {
            "value": "明溪县"
          },
          {
            "value": "清流县"
          },
          {
            "value": "宁化县"
          },
          {
            "value": "大田县"
          },
          {
            "value": "尤溪县"
          },
          {
            "value": "将乐县"
          },
          {
            "value": "泰宁县"
          },
          {
            "value": "建宁县"
          },
          {
            "value": "永安市"
          }
        ]
      },
      {
        "city": "泉州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "鲤城区"
          },
          {
            "value": "丰泽区"
          },
          {
            "value": "洛江区"
          },
          {
            "value": "泉港区"
          },
          {
            "value": "惠安县"
          },
          {
            "value": "安溪县"
          },
          {
            "value": "永春县"
          },
          {
            "value": "德化县"
          },
          {
            "value": "金门县"
          },
          {
            "value": "石狮市"
          },
          {
            "value": "晋江市"
          },
          {
            "value": "南安市"
          }
        ]
      },
      {
        "city": "漳州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "芗城区"
          },
          {
            "value": "龙文区"
          },
          {
            "value": "龙海区"
          },
          {
            "value": "长泰区"
          },
          {
            "value": "云霄县"
          },
          {
            "value": "漳浦县"
          },
          {
            "value": "诏安县"
          },
          {
            "value": "东山县"
          },
          {
            "value": "南靖县"
          },
          {
            "value": "平和县"
          },
          {
            "value": "华安县"
          }
        ]
      },
      {
        "city": "南平市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "延平区"
          },
          {
            "value": "建阳区"
          },
          {
            "value": "顺昌县"
          },
          {
            "value": "浦城县"
          },
          {
            "value": "光泽县"
          },
          {
            "value": "松溪县"
          },
          {
            "value": "政和县"
          },
          {
            "value": "邵武市"
          },
          {
            "value": "武夷山市"
          },
          {
            "value": "建瓯市"
          }
        ]
      },
      {
        "city": "龙岩市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "新罗区"
          },
          {
            "value": "永定区"
          },
          {
            "value": "长汀县"
          },
          {
            "value": "上杭县"
          },
          {
            "value": "武平县"
          },
          {
            "value": "连城县"
          },
          {
            "value": "漳平市"
          }
        ]
      },
      {
        "city": "宁德市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "蕉城区"
          },
          {
            "value": "霞浦县"
          },
          {
            "value": "古田县"
          },
          {
            "value": "屏南县"
          },
          {
            "value": "寿宁县"
          },
          {
            "value": "周宁县"
          },
          {
            "value": "柘荣县"
          },
          {
            "value": "福安市"
          },
          {
            "value": "福鼎市"
          }
        ]
      }
    ]
  },
  
  {
    "value": "江西省",
	 "label": "江西省",
    "children": [
      {
        "city": "南昌市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "东湖区"
          },
          {
            "value": "西湖区"
          },
          {
            "value": "青云谱区"
          },
          {
            "value": "青山湖区"
          },
          {
            "value": "新建区"
          },
          {
            "value": "红谷滩区"
          },
          {
            "value": "南昌县"
          },
          {
            "value": "安义县"
          },
          {
            "value": "进贤县"
          }
        ]
      },
      {
        "city": "景德镇市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "昌江区"
          },
          {
            "value": "珠山区"
          },
          {
            "value": "浮梁县"
          },
          {
            "value": "乐平市"
          }
        ]
      },
      {
        "city": "萍乡市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "安源区"
          },
          {
            "value": "湘东区"
          },
          {
            "value": "莲花县"
          },
          {
            "value": "上栗县"
          },
          {
            "value": "芦溪县"
          }
        ]
      },
      {
        "city": "九江市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "濂溪区"
          },
          {
            "value": "浔阳区"
          },
          {
            "value": "柴桑区"
          },
          {
            "value": "武宁县"
          },
          {
            "value": "修水县"
          },
          {
            "value": "永修县"
          },
          {
            "value": "德安县"
          },
          {
            "value": "都昌县"
          },
          {
            "value": "湖口县"
          },
          {
            "value": "彭泽县"
          },
          {
            "value": "瑞昌市"
          },
          {
            "value": "共青城市"
          },
          {
            "value": "庐山市"
          }
        ]
      },
      {
        "city": "新余市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "渝水区"
          },
          {
            "value": "分宜县"
          }
        ]
      },
      {
        "city": "鹰潭市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "月湖区"
          },
          {
            "value": "余江区"
          },
          {
            "value": "贵溪市"
          }
        ]
      },
      {
        "city": "赣州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "章贡区"
          },
          {
            "value": "南康区"
          },
          {
            "value": "赣县区"
          },
          {
            "value": "信丰县"
          },
          {
            "value": "大余县"
          },
          {
            "value": "上犹县"
          },
          {
            "value": "崇义县"
          },
          {
            "value": "安远县"
          },
          {
            "value": "定南县"
          },
          {
            "value": "全南县"
          },
          {
            "value": "宁都县"
          },
          {
            "value": "于都县"
          },
          {
            "value": "兴国县"
          },
          {
            "value": "会昌县"
          },
          {
            "value": "寻乌县"
          },
          {
            "value": "石城县"
          },
          {
            "value": "瑞金市"
          },
          {
            "value": "龙南市"
          }
        ]
      },
      {
        "city": "吉安市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "吉州区"
          },
          {
            "value": "青原区"
          },
          {
            "value": "吉安县"
          },
          {
            "value": "吉水县"
          },
          {
            "value": "峡江县"
          },
          {
            "value": "新干县"
          },
          {
            "value": "永丰县"
          },
          {
            "value": "泰和县"
          },
          {
            "value": "遂川县"
          },
          {
            "value": "万安县"
          },
          {
            "value": "安福县"
          },
          {
            "value": "永新县"
          },
          {
            "value": "井冈山市"
          }
        ]
      },
      {
        "city": "宜春市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "袁州区"
          },
          {
            "value": "奉新县"
          },
          {
            "value": "万载县"
          },
          {
            "value": "上高县"
          },
          {
            "value": "宜丰县"
          },
          {
            "value": "靖安县"
          },
          {
            "value": "铜鼓县"
          },
          {
            "value": "丰城市"
          },
          {
            "value": "樟树市"
          },
          {
            "value": "高安市"
          }
        ]
      },
      {
        "city": "抚州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "临川区"
          },
          {
            "value": "东乡区"
          },
          {
            "value": "南城县"
          },
          {
            "value": "黎川县"
          },
          {
            "value": "南丰县"
          },
          {
            "value": "崇仁县"
          },
          {
            "value": "乐安县"
          },
          {
            "value": "宜黄县"
          },
          {
            "value": "金溪县"
          },
          {
            "value": "资溪县"
          },
          {
            "value": "广昌县"
          }
        ]
      },
      {
        "city": "上饶市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "信州区"
          },
          {
            "value": "广丰区"
          },
          {
            "value": "广信区"
          },
          {
            "value": "玉山县"
          },
          {
            "value": "铅山县"
          },
          {
            "value": "横峰县"
          },
          {
            "value": "弋阳县"
          },
          {
            "value": "余干县"
          },
          {
            "value": "鄱阳县"
          },
          {
            "value": "万年县"
          },
          {
            "value": "婺源县"
          },
          {
            "value": "德兴市"
          }
        ]
      }
    ]
  },
  
  {
    "value": "山东省",
	 "label": "山东省",
    "children": [
      {
        "city": "济南市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "历下区"
          },
          {
            "value": "市中区"
          },
          {
            "value": "槐荫区"
          },
          {
            "value": "天桥区"
          },
          {
            "value": "历城区"
          },
          {
            "value": "长清区"
          },
          {
            "value": "章丘区"
          },
          {
            "value": "济阳区"
          },
          {
            "value": "莱芜区"
          },
          {
            "value": "钢城区"
          },
          {
            "value": "平阴县"
          },
          {
            "value": "商河县"
          }
        ]
      },
      {
        "city": "青岛市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "市南区"
          },
          {
            "value": "市北区"
          },
          {
            "value": "黄岛区"
          },
          {
            "value": "崂山区"
          },
          {
            "value": "李沧区"
          },
          {
            "value": "城阳区"
          },
          {
            "value": "即墨区"
          },
          {
            "value": "胶州市"
          },
          {
            "value": "平度市"
          },
          {
            "value": "莱西市"
          }
        ]
      },
      {
        "city": "淄博市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "淄川区"
          },
          {
            "value": "张店区"
          },
          {
            "value": "博山区"
          },
          {
            "value": "临淄区"
          },
          {
            "value": "周村区"
          },
          {
            "value": "桓台县"
          },
          {
            "value": "高青县"
          },
          {
            "value": "沂源县"
          }
        ]
      },
      {
        "city": "枣庄市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "市中区"
          },
          {
            "value": "薛城区"
          },
          {
            "value": "峄城区"
          },
          {
            "value": "台儿庄区"
          },
          {
            "value": "山亭区"
          },
          {
            "value": "滕州市"
          }
        ]
      },
      {
        "city": "东营市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "东营区"
          },
          {
            "value": "河口区"
          },
          {
            "value": "垦利区"
          },
          {
            "value": "利津县"
          },
          {
            "value": "广饶县"
          }
        ]
      },
      {
        "city": "烟台市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "芝罘区"
          },
          {
            "value": "福山区"
          },
          {
            "value": "牟平区"
          },
          {
            "value": "莱山区"
          },
          {
            "value": "蓬莱区"
          },
          {
            "value": "龙口市"
          },
          {
            "value": "莱阳市"
          },
          {
            "value": "莱州市"
          },
          {
            "value": "招远市"
          },
          {
            "value": "栖霞市"
          },
          {
            "value": "海阳市"
          }
        ]
      },
      {
        "city": "潍坊市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "潍城区"
          },
          {
            "value": "寒亭区"
          },
          {
            "value": "坊子区"
          },
          {
            "value": "奎文区"
          },
          {
            "value": "临朐县"
          },
          {
            "value": "昌乐县"
          },
          {
            "value": "青州市"
          },
          {
            "value": "诸城市"
          },
          {
            "value": "寿光市"
          },
          {
            "value": "安丘市"
          },
          {
            "value": "高密市"
          },
          {
            "value": "昌邑市"
          }
        ]
      },
      {
        "city": "济宁市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "任城区"
          },
          {
            "value": "兖州区"
          },
          {
            "value": "微山县"
          },
          {
            "value": "鱼台县"
          },
          {
            "value": "金乡县"
          },
          {
            "value": "嘉祥县"
          },
          {
            "value": "汶上县"
          },
          {
            "value": "泗水县"
          },
          {
            "value": "梁山县"
          },
          {
            "value": "曲阜市"
          },
          {
            "value": "邹城市"
          }
        ]
      },
      {
        "city": "泰安市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "泰山区"
          },
          {
            "value": "岱岳区"
          },
          {
            "value": "宁阳县"
          },
          {
            "value": "东平县"
          },
          {
            "value": "新泰市"
          },
          {
            "value": "肥城市"
          }
        ]
      },
      {
        "city": "威海市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "环翠区"
          },
          {
            "value": "文登区"
          },
          {
            "value": "荣成市"
          },
          {
            "value": "乳山市"
          }
        ]
      },
      {
        "city": "日照市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "东港区"
          },
          {
            "value": "岚山区"
          },
          {
            "value": "五莲县"
          },
          {
            "value": "莒县"
          }
        ]
      },
      {
        "city": "临沂市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "兰山区"
          },
          {
            "value": "罗庄区"
          },
          {
            "value": "河东区"
          },
          {
            "value": "沂南县"
          },
          {
            "value": "郯城县"
          },
          {
            "value": "沂水县"
          },
          {
            "value": "兰陵县"
          },
          {
            "value": "费县"
          },
          {
            "value": "平邑县"
          },
          {
            "value": "莒南县"
          },
          {
            "value": "蒙阴县"
          },
          {
            "value": "临沭县"
          }
        ]
      },
      {
        "city": "德州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "德城区"
          },
          {
            "value": "陵城区"
          },
          {
            "value": "宁津县"
          },
          {
            "value": "庆云县"
          },
          {
            "value": "临邑县"
          },
          {
            "value": "齐河县"
          },
          {
            "value": "平原县"
          },
          {
            "value": "夏津县"
          },
          {
            "value": "武城县"
          },
          {
            "value": "乐陵市"
          },
          {
            "value": "禹城市"
          }
        ]
      },
      {
        "city": "聊城市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "东昌府区"
          },
          {
            "value": "茌平区"
          },
          {
            "value": "阳谷县"
          },
          {
            "value": "莘县"
          },
          {
            "value": "东阿县"
          },
          {
            "value": "冠县"
          },
          {
            "value": "高唐县"
          },
          {
            "value": "临清市"
          }
        ]
      },
      {
        "city": "滨州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "滨城区"
          },
          {
            "value": "沾化区"
          },
          {
            "value": "惠民县"
          },
          {
            "value": "阳信县"
          },
          {
            "value": "无棣县"
          },
          {
            "value": "博兴县"
          },
          {
            "value": "邹平市"
          }
        ]
      },
      {
        "city": "菏泽市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "牡丹区"
          },
          {
            "value": "定陶区"
          },
          {
            "value": "曹县"
          },
          {
            "value": "单县"
          },
          {
            "value": "成武县"
          },
          {
            "value": "巨野县"
          },
          {
            "value": "郓城县"
          },
          {
            "value": "鄄城县"
          },
          {
            "value": "东明县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "河南省",
	 "label": "河南省",
    "children": [
      {
        "city": "郑州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "中原区"
          },
          {
            "value": "二七区"
          },
          {
            "value": "管城回族区"
          },
          {
            "value": "金水区"
          },
          {
            "value": "上街区"
          },
          {
            "value": "惠济区"
          },
          {
            "value": "中牟县"
          },
          {
            "value": "巩义市"
          },
          {
            "value": "荥阳市"
          },
          {
            "value": "新密市"
          },
          {
            "value": "新郑市"
          },
          {
            "value": "登封市"
          }
        ]
      },
      {
        "city": "开封市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "龙亭区"
          },
          {
            "value": "顺河回族区"
          },
          {
            "value": "鼓楼区"
          },
          {
            "value": "禹王台区"
          },
          {
            "value": "祥符区"
          },
          {
            "value": "杞县"
          },
          {
            "value": "通许县"
          },
          {
            "value": "尉氏县"
          },
          {
            "value": "兰考县"
          }
        ]
      },
      {
        "city": "洛阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "老城区"
          },
          {
            "value": "西工区"
          },
          {
            "value": "瀍河回族区"
          },
          {
            "value": "涧西区"
          },
          {
            "value": "偃师区"
          },
          {
            "value": "孟津区"
          },
          {
            "value": "洛龙区"
          },
          {
            "value": "新安县"
          },
          {
            "value": "栾川县"
          },
          {
            "value": "嵩县"
          },
          {
            "value": "汝阳县"
          },
          {
            "value": "宜阳县"
          },
          {
            "value": "洛宁县"
          },
          {
            "value": "伊川县"
          }
        ]
      },
      {
        "city": "平顶山市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "新华区"
          },
          {
            "value": "卫东区"
          },
          {
            "value": "石龙区"
          },
          {
            "value": "湛河区"
          },
          {
            "value": "宝丰县"
          },
          {
            "value": "叶县"
          },
          {
            "value": "鲁山县"
          },
          {
            "value": "郏县"
          },
          {
            "value": "舞钢市"
          },
          {
            "value": "汝州市"
          }
        ]
      },
      {
        "city": "安阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "文峰区"
          },
          {
            "value": "北关区"
          },
          {
            "value": "殷都区"
          },
          {
            "value": "龙安区"
          },
          {
            "value": "安阳县"
          },
          {
            "value": "汤阴县"
          },
          {
            "value": "滑县"
          },
          {
            "value": "内黄县"
          },
          {
            "value": "林州市"
          }
        ]
      },
      {
        "city": "鹤壁市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "鹤山区"
          },
          {
            "value": "山城区"
          },
          {
            "value": "淇滨区"
          },
          {
            "value": "浚县"
          },
          {
            "value": "淇县"
          }
        ]
      },
      {
        "city": "新乡市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "红旗区"
          },
          {
            "value": "卫滨区"
          },
          {
            "value": "凤泉区"
          },
          {
            "value": "牧野区"
          },
          {
            "value": "新乡县"
          },
          {
            "value": "获嘉县"
          },
          {
            "value": "原阳县"
          },
          {
            "value": "延津县"
          },
          {
            "value": "封丘县"
          },
          {
            "value": "卫辉市"
          },
          {
            "value": "辉县市"
          },
          {
            "value": "长垣市"
          }
        ]
      },
      {
        "city": "焦作市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "解放区"
          },
          {
            "value": "中站区"
          },
          {
            "value": "马村区"
          },
          {
            "value": "山阳区"
          },
          {
            "value": "修武县"
          },
          {
            "value": "博爱县"
          },
          {
            "value": "武陟县"
          },
          {
            "value": "温县"
          },
          {
            "value": "沁阳市"
          },
          {
            "value": "孟州市"
          }
        ]
      },
      {
        "city": "濮阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "华龙区"
          },
          {
            "value": "清丰县"
          },
          {
            "value": "南乐县"
          },
          {
            "value": "范县"
          },
          {
            "value": "台前县"
          },
          {
            "value": "濮阳县"
          }
        ]
      },
      {
        "city": "许昌市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "魏都区"
          },
          {
            "value": "建安区"
          },
          {
            "value": "鄢陵县"
          },
          {
            "value": "襄城县"
          },
          {
            "value": "禹州市"
          },
          {
            "value": "长葛市"
          }
        ]
      },
      {
        "city": "漯河市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "源汇区"
          },
          {
            "value": "郾城区"
          },
          {
            "value": "召陵区"
          },
          {
            "value": "舞阳县"
          },
          {
            "value": "临颍县"
          }
        ]
      },
      {
        "city": "三门峡市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "湖滨区"
          },
          {
            "value": "陕州区"
          },
          {
            "value": "渑池县"
          },
          {
            "value": "卢氏县"
          },
          {
            "value": "义马市"
          },
          {
            "value": "灵宝市"
          }
        ]
      },
      {
        "city": "南阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "宛城区"
          },
          {
            "value": "卧龙区"
          },
          {
            "value": "南召县"
          },
          {
            "value": "方城县"
          },
          {
            "value": "西峡县"
          },
          {
            "value": "镇平县"
          },
          {
            "value": "内乡县"
          },
          {
            "value": "淅川县"
          },
          {
            "value": "社旗县"
          },
          {
            "value": "唐河县"
          },
          {
            "value": "新野县"
          },
          {
            "value": "桐柏县"
          },
          {
            "value": "邓州市"
          }
        ]
      },
      {
        "city": "商丘市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "梁园区"
          },
          {
            "value": "睢阳区"
          },
          {
            "value": "民权县"
          },
          {
            "value": "睢县"
          },
          {
            "value": "宁陵县"
          },
          {
            "value": "柘城县"
          },
          {
            "value": "虞城县"
          },
          {
            "value": "夏邑县"
          },
          {
            "value": "永城市"
          }
        ]
      },
      {
        "city": "信阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "浉河区"
          },
          {
            "value": "平桥区"
          },
          {
            "value": "罗山县"
          },
          {
            "value": "光山县"
          },
          {
            "value": "新县"
          },
          {
            "value": "商城县"
          },
          {
            "value": "固始县"
          },
          {
            "value": "潢川县"
          },
          {
            "value": "淮滨县"
          },
          {
            "value": "息县"
          }
        ]
      },
      {
        "city": "周口市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "川汇区"
          },
          {
            "value": "淮阳区"
          },
          {
            "value": "扶沟县"
          },
          {
            "value": "西华县"
          },
          {
            "value": "商水县"
          },
          {
            "value": "沈丘县"
          },
          {
            "value": "郸城县"
          },
          {
            "value": "太康县"
          },
          {
            "value": "鹿邑县"
          },
          {
            "value": "项城市"
          }
        ]
      },
      {
        "city": "驻马店市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "驿城区"
          },
          {
            "value": "西平县"
          },
          {
            "value": "上蔡县"
          },
          {
            "value": "平舆县"
          },
          {
            "value": "正阳县"
          },
          {
            "value": "确山县"
          },
          {
            "value": "泌阳县"
          },
          {
            "value": "汝南县"
          },
          {
            "value": "遂平县"
          },
          {
            "value": "新蔡县"
          },
          {
            "value": "济源市"
          }
        ]
      }
    ]
  },
  
  {
    "value": "湖北省",
	 "label": "湖北省",
    "children": [
      {
        "city": "武汉市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "江岸区"
          },
          {
            "value": "江汉区"
          },
          {
            "value": "硚口区"
          },
          {
            "value": "汉阳区"
          },
          {
            "value": "武昌区"
          },
          {
            "value": "青山区"
          },
          {
            "value": "洪山区"
          },
          {
            "value": "东西湖区"
          },
          {
            "value": "汉南区"
          },
          {
            "value": "蔡甸区"
          },
          {
            "value": "江夏区"
          },
          {
            "value": "黄陂区"
          },
          {
            "value": "新洲区"
          }
        ]
      },
      {
        "city": "黄石市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "黄石港区"
          },
          {
            "value": "西塞山区"
          },
          {
            "value": "下陆区"
          },
          {
            "value": "铁山区"
          },
          {
            "value": "阳新县"
          },
          {
            "value": "大冶市"
          }
        ]
      },
      {
        "city": "十堰市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "茅箭区"
          },
          {
            "value": "张湾区"
          },
          {
            "value": "郧阳区"
          },
          {
            "value": "郧西县"
          },
          {
            "value": "竹山县"
          },
          {
            "value": "竹溪县"
          },
          {
            "value": "房县"
          },
          {
            "value": "丹江口市"
          }
        ]
      },
      {
        "city": "宜昌市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "西陵区"
          },
          {
            "value": "伍家岗区"
          },
          {
            "value": "点军区"
          },
          {
            "value": "猇亭区"
          },
          {
            "value": "夷陵区"
          },
          {
            "value": "远安县"
          },
          {
            "value": "兴山县"
          },
          {
            "value": "秭归县"
          },
          {
            "value": "长阳土家族自治县"
          },
          {
            "value": "五峰土家族自治县"
          },
          {
            "value": "宜都市"
          },
          {
            "value": "当阳市"
          },
          {
            "value": "枝江市"
          }
        ]
      },
      {
        "city": "襄阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "襄城区"
          },
          {
            "value": "樊城区"
          },
          {
            "value": "襄州区"
          },
          {
            "value": "南漳县"
          },
          {
            "value": "谷城县"
          },
          {
            "value": "保康县"
          },
          {
            "value": "老河口市"
          },
          {
            "value": "枣阳市"
          },
          {
            "value": "宜城市"
          }
        ]
      },
      {
        "city": "鄂州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "梁子湖区"
          },
          {
            "value": "华容区"
          },
          {
            "value": "鄂城区"
          }
        ]
      },
      {
        "city": "荆门市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "东宝区"
          },
          {
            "value": "掇刀区"
          },
          {
            "value": "沙洋县"
          },
          {
            "value": "钟祥市"
          },
          {
            "value": "京山市"
          }
        ]
      },
      {
        "city": "孝感市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "孝南区"
          },
          {
            "value": "孝昌县"
          },
          {
            "value": "大悟县"
          },
          {
            "value": "云梦县"
          },
          {
            "value": "应城市"
          },
          {
            "value": "安陆市"
          },
          {
            "value": "汉川市"
          }
        ]
      },
      {
        "city": "荆州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "沙市区"
          },
          {
            "value": "荆州区"
          },
          {
            "value": "公安县"
          },
          {
            "value": "江陵县"
          },
          {
            "value": "石首市"
          },
          {
            "value": "洪湖市"
          },
          {
            "value": "松滋市"
          },
          {
            "value": "监利市"
          }
        ]
      },
      {
        "city": "黄冈市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "黄州区"
          },
          {
            "value": "团风县"
          },
          {
            "value": "红安县"
          },
          {
            "value": "罗田县"
          },
          {
            "value": "英山县"
          },
          {
            "value": "浠水县"
          },
          {
            "value": "蕲春县"
          },
          {
            "value": "黄梅县"
          },
          {
            "value": "麻城市"
          },
          {
            "value": "武穴市"
          }
        ]
      },
      {
        "city": "咸宁市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "咸安区"
          },
          {
            "value": "嘉鱼县"
          },
          {
            "value": "通城县"
          },
          {
            "value": "崇阳县"
          },
          {
            "value": "通山县"
          },
          {
            "value": "赤壁市"
          }
        ]
      },
      {
        "city": "随州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "曾都区"
          },
          {
            "value": "随县"
          },
          {
            "value": "广水市"
          }
        ]
      },
      {
        "city": "恩施土家族苗族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "恩施市"
          },
          {
            "value": "利川市"
          },
          {
            "value": "建始县"
          },
          {
            "value": "巴东县"
          },
          {
            "value": "宣恩县"
          },
          {
            "value": "咸丰县"
          },
          {
            "value": "来凤县"
          },
          {
            "value": "鹤峰县"
          },
          {
            "value": "仙桃市"
          },
          {
            "value": "潜江市"
          },
          {
            "value": "天门市"
          },
          {
            "value": "神农架林区"
          }
        ]
      }
    ]
  },
  
  {
    "value": "湖南省",
	 "label": "湖南省",
    "children": [
      {
        "city": "长沙市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "芙蓉区"
          },
          {
            "value": "天心区"
          },
          {
            "value": "岳麓区"
          },
          {
            "value": "开福区"
          },
          {
            "value": "雨花区"
          },
          {
            "value": "望城区"
          },
          {
            "value": "长沙县"
          },
          {
            "value": "浏阳市"
          },
          {
            "value": "宁乡市"
          }
        ]
      },
      {
        "city": "株洲市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "荷塘区"
          },
          {
            "value": "芦淞区"
          },
          {
            "value": "石峰区"
          },
          {
            "value": "天元区"
          },
          {
            "value": "渌口区"
          },
          {
            "value": "攸县"
          },
          {
            "value": "茶陵县"
          },
          {
            "value": "炎陵县"
          },
          {
            "value": "醴陵市"
          }
        ]
      },
      {
        "city": "湘潭市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "雨湖区"
          },
          {
            "value": "岳塘区"
          },
          {
            "value": "湘潭县"
          },
          {
            "value": "湘乡市"
          },
          {
            "value": "韶山市"
          }
        ]
      },
      {
        "city": "衡阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "珠晖区"
          },
          {
            "value": "雁峰区"
          },
          {
            "value": "石鼓区"
          },
          {
            "value": "蒸湘区"
          },
          {
            "value": "南岳区"
          },
          {
            "value": "衡阳县"
          },
          {
            "value": "衡南县"
          },
          {
            "value": "衡山县"
          },
          {
            "value": "衡东县"
          },
          {
            "value": "祁东县"
          },
          {
            "value": "耒阳市"
          },
          {
            "value": "常宁市"
          }
        ]
      },
      {
        "city": "邵阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "双清区"
          },
          {
            "value": "大祥区"
          },
          {
            "value": "北塔区"
          },
          {
            "value": "新邵县"
          },
          {
            "value": "邵阳县"
          },
          {
            "value": "隆回县"
          },
          {
            "value": "洞口县"
          },
          {
            "value": "绥宁县"
          },
          {
            "value": "新宁县"
          },
          {
            "value": "城步苗族自治县"
          },
          {
            "value": "武冈市"
          },
          {
            "value": "邵东市"
          }
        ]
      },
      {
        "city": "岳阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "岳阳楼区"
          },
          {
            "value": "云溪区"
          },
          {
            "value": "君山区"
          },
          {
            "value": "岳阳县"
          },
          {
            "value": "华容县"
          },
          {
            "value": "湘阴县"
          },
          {
            "value": "平江县"
          },
          {
            "value": "汨罗市"
          },
          {
            "value": "临湘市"
          }
        ]
      },
      {
        "city": "常德市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "武陵区"
          },
          {
            "value": "鼎城区"
          },
          {
            "value": "安乡县"
          },
          {
            "value": "汉寿县"
          },
          {
            "value": "澧县"
          },
          {
            "value": "临澧县"
          },
          {
            "value": "桃源县"
          },
          {
            "value": "石门县"
          },
          {
            "value": "津市市"
          }
        ]
      },
      {
        "city": "张家界市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "永定区"
          },
          {
            "value": "武陵源区"
          },
          {
            "value": "慈利县"
          },
          {
            "value": "桑植县"
          }
        ]
      },
      {
        "city": "益阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "资阳区"
          },
          {
            "value": "赫山区"
          },
          {
            "value": "南县"
          },
          {
            "value": "桃江县"
          },
          {
            "value": "安化县"
          },
          {
            "value": "沅江市"
          }
        ]
      },
      {
        "city": "郴州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "北湖区"
          },
          {
            "value": "苏仙区"
          },
          {
            "value": "桂阳县"
          },
          {
            "value": "宜章县"
          },
          {
            "value": "永兴县"
          },
          {
            "value": "嘉禾县"
          },
          {
            "value": "临武县"
          },
          {
            "value": "汝城县"
          },
          {
            "value": "桂东县"
          },
          {
            "value": "安仁县"
          },
          {
            "value": "资兴市"
          }
        ]
      },
      {
        "city": "永州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "零陵区"
          },
          {
            "value": "冷水滩区"
          },
          {
            "value": "东安县"
          },
          {
            "value": "双牌县"
          },
          {
            "value": "道县"
          },
          {
            "value": "江永县"
          },
          {
            "value": "宁远县"
          },
          {
            "value": "蓝山县"
          },
          {
            "value": "新田县"
          },
          {
            "value": "江华瑶族自治县"
          },
          {
            "value": "祁阳市"
          }
        ]
      },
      {
        "city": "怀化市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "鹤城区"
          },
          {
            "value": "中方县"
          },
          {
            "value": "沅陵县"
          },
          {
            "value": "辰溪县"
          },
          {
            "value": "溆浦县"
          },
          {
            "value": "会同县"
          },
          {
            "value": "麻阳苗族自治县"
          },
          {
            "value": "新晃侗族自治县"
          },
          {
            "value": "芷江侗族自治县"
          },
          {
            "value": "靖州苗族侗族自治县"
          },
          {
            "value": "通道侗族自治县"
          },
          {
            "value": "洪江市"
          }
        ]
      },
      {
        "city": "娄底市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "娄星区"
          },
          {
            "value": "双峰县"
          },
          {
            "value": "新化县"
          },
          {
            "value": "冷水江市"
          },
          {
            "value": "涟源市"
          }
        ]
      },
      {
        "city": "湘西土家族苗族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "吉首市"
          },
          {
            "value": "泸溪县"
          },
          {
            "value": "凤凰县"
          },
          {
            "value": "花垣县"
          },
          {
            "value": "保靖县"
          },
          {
            "value": "古丈县"
          },
          {
            "value": "永顺县"
          },
          {
            "value": "龙山县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "广东省",
	 "label": "广东省",
    "children": [
      {
        "city": "广州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "荔湾区"
          },
          {
            "value": "越秀区"
          },
          {
            "value": "海珠区"
          },
          {
            "value": "天河区"
          },
          {
            "value": "白云区"
          },
          {
            "value": "黄埔区"
          },
          {
            "value": "番禺区"
          },
          {
            "value": "花都区"
          },
          {
            "value": "南沙区"
          },
          {
            "value": "从化区"
          },
          {
            "value": "增城区"
          }
        ]
      },
      {
        "city": "韶关市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "武江区"
          },
          {
            "value": "浈江区"
          },
          {
            "value": "曲江区"
          },
          {
            "value": "始兴县"
          },
          {
            "value": "仁化县"
          },
          {
            "value": "翁源县"
          },
          {
            "value": "乳源瑶族自治县"
          },
          {
            "value": "新丰县"
          },
          {
            "value": "乐昌市"
          },
          {
            "value": "南雄市"
          }
        ]
      },
      {
        "city": "深圳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "罗湖区"
          },
          {
            "value": "福田区"
          },
          {
            "value": "南山区"
          },
          {
            "value": "宝安区"
          },
          {
            "value": "龙岗区"
          },
          {
            "value": "盐田区"
          },
          {
            "value": "龙华区"
          },
          {
            "value": "坪山区"
          },
          {
            "value": "光明区"
          }
        ]
      },
      {
        "city": "珠海市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "香洲区"
          },
          {
            "value": "斗门区"
          },
          {
            "value": "金湾区"
          }
        ]
      },
      {
        "city": "汕头市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "龙湖区"
          },
          {
            "value": "金平区"
          },
          {
            "value": "濠江区"
          },
          {
            "value": "潮阳区"
          },
          {
            "value": "潮南区"
          },
          {
            "value": "澄海区"
          },
          {
            "value": "南澳县"
          }
        ]
      },
      {
        "city": "佛山市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "禅城区"
          },
          {
            "value": "南海区"
          },
          {
            "value": "顺德区"
          },
          {
            "value": "三水区"
          },
          {
            "value": "高明区"
          }
        ]
      },
      {
        "city": "江门市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "蓬江区"
          },
          {
            "value": "江海区"
          },
          {
            "value": "新会区"
          },
          {
            "value": "台山市"
          },
          {
            "value": "开平市"
          },
          {
            "value": "鹤山市"
          },
          {
            "value": "恩平市"
          }
        ]
      },
      {
        "city": "湛江市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "赤坎区"
          },
          {
            "value": "霞山区"
          },
          {
            "value": "坡头区"
          },
          {
            "value": "麻章区"
          },
          {
            "value": "遂溪县"
          },
          {
            "value": "徐闻县"
          },
          {
            "value": "廉江市"
          },
          {
            "value": "雷州市"
          },
          {
            "value": "吴川市"
          }
        ]
      },
      {
        "city": "茂名市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "茂南区"
          },
          {
            "value": "电白区"
          },
          {
            "value": "高州市"
          },
          {
            "value": "化州市"
          },
          {
            "value": "信宜市"
          }
        ]
      },
      {
        "city": "肇庆市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "端州区"
          },
          {
            "value": "鼎湖区"
          },
          {
            "value": "高要区"
          },
          {
            "value": "广宁县"
          },
          {
            "value": "怀集县"
          },
          {
            "value": "封开县"
          },
          {
            "value": "德庆县"
          },
          {
            "value": "四会市"
          }
        ]
      },
      {
        "city": "惠州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "惠城区"
          },
          {
            "value": "惠阳区"
          },
          {
            "value": "博罗县"
          },
          {
            "value": "惠东县"
          },
          {
            "value": "龙门县"
          }
        ]
      },
      {
        "city": "梅州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "梅江区"
          },
          {
            "value": "梅县区"
          },
          {
            "value": "大埔县"
          },
          {
            "value": "丰顺县"
          },
          {
            "value": "五华县"
          },
          {
            "value": "平远县"
          },
          {
            "value": "蕉岭县"
          },
          {
            "value": "兴宁市"
          }
        ]
      },
      {
        "city": "汕尾市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "城区"
          },
          {
            "value": "海丰县"
          },
          {
            "value": "陆河县"
          },
          {
            "value": "陆丰市"
          }
        ]
      },
      {
        "city": "河源市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "源城区"
          },
          {
            "value": "紫金县"
          },
          {
            "value": "龙川县"
          },
          {
            "value": "连平县"
          },
          {
            "value": "和平县"
          },
          {
            "value": "东源县"
          }
        ]
      },
      {
        "city": "阳江市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "江城区"
          },
          {
            "value": "阳东区"
          },
          {
            "value": "阳西县"
          },
          {
            "value": "阳春市"
          }
        ]
      },
      {
        "city": "清远市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "清城区"
          },
          {
            "value": "清新区"
          },
          {
            "value": "佛冈县"
          },
          {
            "value": "阳山县"
          },
          {
            "value": "连山壮族瑶族自治县"
          },
          {
            "value": "连南瑶族自治县"
          },
          {
            "value": "英德市"
          },
          {
            "value": "连州市"
          }
        ]
      },
      {
        "city": "潮州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "湘桥区"
          },
          {
            "value": "潮安区"
          },
          {
            "value": "饶平县"
          }
        ]
      },
      {
        "city": "揭阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "榕城区"
          },
          {
            "value": "揭东区"
          },
          {
            "value": "揭西县"
          },
          {
            "value": "惠来县"
          },
          {
            "value": "普宁市"
          }
        ]
      },
      {
        "city": "云浮市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "云城区"
          },
          {
            "value": "云安区"
          },
          {
            "value": "新兴县"
          },
          {
            "value": "郁南县"
          },
          {
            "value": "罗定市"
          }
        ]
      }
    ]
  },
  
  {
    "value": "广西壮族自治区",
	 "label": "广西壮族自治区",
    "children": [
      {
        "city": "南宁市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "兴宁区"
          },
          {
            "value": "青秀区"
          },
          {
            "value": "江南区"
          },
          {
            "value": "西乡塘区"
          },
          {
            "value": "良庆区"
          },
          {
            "value": "邕宁区"
          },
          {
            "value": "武鸣区"
          },
          {
            "value": "隆安县"
          },
          {
            "value": "马山县"
          },
          {
            "value": "上林县"
          },
          {
            "value": "宾阳县"
          },
          {
            "value": "横州市"
          }
        ]
      },
      {
        "city": "柳州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "城中区"
          },
          {
            "value": "鱼峰区"
          },
          {
            "value": "柳南区"
          },
          {
            "value": "柳北区"
          },
          {
            "value": "柳江区"
          },
          {
            "value": "柳城县"
          },
          {
            "value": "鹿寨县"
          },
          {
            "value": "融安县"
          },
          {
            "value": "融水苗族自治县"
          },
          {
            "value": "三江侗族自治县"
          }
        ]
      },
      {
        "city": "桂林市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "秀峰区"
          },
          {
            "value": "叠彩区"
          },
          {
            "value": "象山区"
          },
          {
            "value": "七星区"
          },
          {
            "value": "雁山区"
          },
          {
            "value": "临桂区"
          },
          {
            "value": "阳朔县"
          },
          {
            "value": "灵川县"
          },
          {
            "value": "全州县"
          },
          {
            "value": "兴安县"
          },
          {
            "value": "永福县"
          },
          {
            "value": "灌阳县"
          },
          {
            "value": "龙胜各族自治县"
          },
          {
            "value": "资源县"
          },
          {
            "value": "平乐县"
          },
          {
            "value": "恭城瑶族自治县"
          },
          {
            "value": "荔浦市"
          }
        ]
      },
      {
        "city": "梧州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "万秀区"
          },
          {
            "value": "长洲区"
          },
          {
            "value": "龙圩区"
          },
          {
            "value": "苍梧县"
          },
          {
            "value": "藤县"
          },
          {
            "value": "蒙山县"
          },
          {
            "value": "岑溪市"
          }
        ]
      },
      {
        "city": "北海市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "海城区"
          },
          {
            "value": "银海区"
          },
          {
            "value": "铁山港区"
          },
          {
            "value": "合浦县"
          }
        ]
      },
      {
        "city": "防城港市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "港口区"
          },
          {
            "value": "防城区"
          },
          {
            "value": "上思县"
          },
          {
            "value": "东兴市"
          }
        ]
      },
      {
        "city": "钦州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "钦南区"
          },
          {
            "value": "钦北区"
          },
          {
            "value": "灵山县"
          },
          {
            "value": "浦北县"
          }
        ]
      },
      {
        "city": "贵港市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "港北区"
          },
          {
            "value": "港南区"
          },
          {
            "value": "覃塘区"
          },
          {
            "value": "平南县"
          },
          {
            "value": "桂平市"
          }
        ]
      },
      {
        "city": "玉林市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "玉州区"
          },
          {
            "value": "福绵区"
          },
          {
            "value": "容县"
          },
          {
            "value": "陆川县"
          },
          {
            "value": "博白县"
          },
          {
            "value": "兴业县"
          },
          {
            "value": "北流市"
          }
        ]
      },
      {
        "city": "百色市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "右江区"
          },
          {
            "value": "田阳区"
          },
          {
            "value": "田东县"
          },
          {
            "value": "德保县"
          },
          {
            "value": "那坡县"
          },
          {
            "value": "凌云县"
          },
          {
            "value": "乐业县"
          },
          {
            "value": "田林县"
          },
          {
            "value": "西林县"
          },
          {
            "value": "隆林各族自治县"
          },
          {
            "value": "靖西市"
          },
          {
            "value": "平果市"
          }
        ]
      },
      {
        "city": "贺州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "八步区"
          },
          {
            "value": "平桂区"
          },
          {
            "value": "昭平县"
          },
          {
            "value": "钟山县"
          },
          {
            "value": "富川瑶族自治县"
          }
        ]
      },
      {
        "city": "河池市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "金城江区"
          },
          {
            "value": "宜州区"
          },
          {
            "value": "南丹县"
          },
          {
            "value": "天峨县"
          },
          {
            "value": "凤山县"
          },
          {
            "value": "东兰县"
          },
          {
            "value": "罗城仫佬族自治县"
          },
          {
            "value": "环江毛南族自治县"
          },
          {
            "value": "巴马瑶族自治县"
          },
          {
            "value": "都安瑶族自治县"
          },
          {
            "value": "大化瑶族自治县"
          }
        ]
      },
      {
        "city": "来宾市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "兴宾区"
          },
          {
            "value": "忻城县"
          },
          {
            "value": "象州县"
          },
          {
            "value": "武宣县"
          },
          {
            "value": "金秀瑶族自治县"
          },
          {
            "value": "合山市"
          }
        ]
      },
      {
        "city": "崇左市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "江州区"
          },
          {
            "value": "扶绥县"
          },
          {
            "value": "宁明县"
          },
          {
            "value": "龙州县"
          },
          {
            "value": "大新县"
          },
          {
            "value": "天等县"
          },
          {
            "value": "凭祥市"
          }
        ]
      }
    ]
  },
  
  {
    "value": "海南省",
	 "label": "海南省",
    "children": [
      {
        "city": "海口市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "秀英区"
          },
          {
            "value": "龙华区"
          },
          {
            "value": "琼山区"
          },
          {
            "value": "美兰区"
          }
        ]
      },
      {
        "city": "三亚市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "海棠区"
          },
          {
            "value": "吉阳区"
          },
          {
            "value": "天涯区"
          },
          {
            "value": "崖州区"
          }
        ]
      },
      {
        "city": "儋州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "五指山市"
          },
          {
            "value": "琼海市"
          },
          {
            "value": "文昌市"
          },
          {
            "value": "万宁市"
          },
          {
            "value": "东方市"
          },
          {
            "value": "定安县"
          },
          {
            "value": "屯昌县"
          },
          {
            "value": "澄迈县"
          },
          {
            "value": "临高县"
          },
          {
            "value": "白沙黎族自治县"
          },
          {
            "value": "昌江黎族自治县"
          },
          {
            "value": "乐东黎族自治县"
          },
          {
            "value": "陵水黎族自治县"
          },
          {
            "value": "保亭黎族苗族自治县"
          },
          {
            "value": "琼中黎族苗族自治县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "重庆市",
	 "label": "重庆市",
    "children": [
      {
        "city": "重庆市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "万州区"
          },
          {
            "value": "涪陵区"
          },
          {
            "value": "渝中区"
          },
          {
            "value": "大渡口区"
          },
          {
            "value": "江北区"
          },
          {
            "value": "沙坪坝区"
          },
          {
            "value": "九龙坡区"
          },
          {
            "value": "南岸区"
          },
          {
            "value": "北碚区"
          },
          {
            "value": "綦江区"
          },
          {
            "value": "大足区"
          },
          {
            "value": "渝北区"
          },
          {
            "value": "巴南区"
          },
          {
            "value": "黔江区"
          },
          {
            "value": "长寿区"
          },
          {
            "value": "江津区"
          },
          {
            "value": "合川区"
          },
          {
            "value": "永川区"
          },
          {
            "value": "南川区"
          },
          {
            "value": "璧山区"
          },
          {
            "value": "铜梁区"
          },
          {
            "value": "潼南区"
          },
          {
            "value": "荣昌区"
          },
          {
            "value": "开州区"
          },
          {
            "value": "梁平区"
          },
          {
            "value": "武隆区"
          },
          {
            "value": "城口县"
          },
          {
            "value": "丰都县"
          },
          {
            "value": "垫江县"
          },
          {
            "value": "忠县"
          },
          {
            "value": "云阳县"
          },
          {
            "value": "奉节县"
          },
          {
            "value": "巫山县"
          },
          {
            "value": "巫溪县"
          },
          {
            "value": "石柱土家族自治县"
          },
          {
            "value": "秀山土家族苗族自治县"
          },
          {
            "value": "酉阳土家族苗族自治县"
          },
          {
            "value": "彭水苗族土家族自治县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "四川省",
	 "label": "四川省",
    "children": [
      {
        "city": "成都市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "锦江区"
          },
          {
            "value": "青羊区"
          },
          {
            "value": "金牛区"
          },
          {
            "value": "武侯区"
          },
          {
            "value": "成华区"
          },
          {
            "value": "龙泉驿区"
          },
          {
            "value": "青白江区"
          },
          {
            "value": "新都区"
          },
          {
            "value": "温江区"
          },
          {
            "value": "双流区"
          },
          {
            "value": "郫都区"
          },
          {
            "value": "新津区"
          },
          {
            "value": "金堂县"
          },
          {
            "value": "大邑县"
          },
          {
            "value": "蒲江县"
          },
          {
            "value": "都江堰市"
          },
          {
            "value": "彭州市"
          },
          {
            "value": "邛崃市"
          },
          {
            "value": "崇州市"
          },
          {
            "value": "简阳市"
          }
        ]
      },
      {
        "city": "自贡市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "自流井区"
          },
          {
            "value": "贡井区"
          },
          {
            "value": "大安区"
          },
          {
            "value": "沿滩区"
          },
          {
            "value": "荣县"
          },
          {
            "value": "富顺县"
          }
        ]
      },
      {
        "city": "攀枝花市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "东区"
          },
          {
            "value": "西区"
          },
          {
            "value": "仁和区"
          },
          {
            "value": "米易县"
          },
          {
            "value": "盐边县"
          }
        ]
      },
      {
        "city": "泸州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "江阳区"
          },
          {
            "value": "纳溪区"
          },
          {
            "value": "龙马潭区"
          },
          {
            "value": "泸县"
          },
          {
            "value": "合江县"
          },
          {
            "value": "叙永县"
          },
          {
            "value": "古蔺县"
          }
        ]
      },
      {
        "city": "德阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "旌阳区"
          },
          {
            "value": "罗江区"
          },
          {
            "value": "中江县"
          },
          {
            "value": "广汉市"
          },
          {
            "value": "什邡市"
          },
          {
            "value": "绵竹市"
          }
        ]
      },
      {
        "city": "绵阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "涪城区"
          },
          {
            "value": "游仙区"
          },
          {
            "value": "安州区"
          },
          {
            "value": "三台县"
          },
          {
            "value": "盐亭县"
          },
          {
            "value": "梓潼县"
          },
          {
            "value": "北川羌族自治县"
          },
          {
            "value": "平武县"
          },
          {
            "value": "江油市"
          }
        ]
      },
      {
        "city": "广元市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "利州区"
          },
          {
            "value": "昭化区"
          },
          {
            "value": "朝天区"
          },
          {
            "value": "旺苍县"
          },
          {
            "value": "青川县"
          },
          {
            "value": "剑阁县"
          },
          {
            "value": "苍溪县"
          }
        ]
      },
      {
        "city": "遂宁市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "船山区"
          },
          {
            "value": "安居区"
          },
          {
            "value": "蓬溪县"
          },
          {
            "value": "大英县"
          },
          {
            "value": "射洪市"
          }
        ]
      },
      {
        "city": "内江市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "市中区"
          },
          {
            "value": "东兴区"
          },
          {
            "value": "威远县"
          },
          {
            "value": "资中县"
          },
          {
            "value": "隆昌市"
          }
        ]
      },
      {
        "city": "乐山市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "市中区"
          },
          {
            "value": "沙湾区"
          },
          {
            "value": "五通桥区"
          },
          {
            "value": "金口河区"
          },
          {
            "value": "犍为县"
          },
          {
            "value": "井研县"
          },
          {
            "value": "夹江县"
          },
          {
            "value": "沐川县"
          },
          {
            "value": "峨边彝族自治县"
          },
          {
            "value": "马边彝族自治县"
          },
          {
            "value": "峨眉山市"
          }
        ]
      },
      {
        "city": "南充市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "顺庆区"
          },
          {
            "value": "高坪区"
          },
          {
            "value": "嘉陵区"
          },
          {
            "value": "南部县"
          },
          {
            "value": "营山县"
          },
          {
            "value": "蓬安县"
          },
          {
            "value": "仪陇县"
          },
          {
            "value": "西充县"
          },
          {
            "value": "阆中市"
          }
        ]
      },
      {
        "city": "眉山市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "东坡区"
          },
          {
            "value": "彭山区"
          },
          {
            "value": "仁寿县"
          },
          {
            "value": "洪雅县"
          },
          {
            "value": "丹棱县"
          },
          {
            "value": "青神县"
          }
        ]
      },
      {
        "city": "宜宾市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "翠屏区"
          },
          {
            "value": "南溪区"
          },
          {
            "value": "叙州区"
          },
          {
            "value": "江安县"
          },
          {
            "value": "长宁县"
          },
          {
            "value": "高县"
          },
          {
            "value": "珙县"
          },
          {
            "value": "筠连县"
          },
          {
            "value": "兴文县"
          },
          {
            "value": "屏山县"
          }
        ]
      },
      {
        "city": "广安市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "广安区"
          },
          {
            "value": "前锋区"
          },
          {
            "value": "岳池县"
          },
          {
            "value": "武胜县"
          },
          {
            "value": "邻水县"
          },
          {
            "value": "华蓥市"
          }
        ]
      },
      {
        "city": "达州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "通川区"
          },
          {
            "value": "达川区"
          },
          {
            "value": "宣汉县"
          },
          {
            "value": "开江县"
          },
          {
            "value": "大竹县"
          },
          {
            "value": "渠县"
          },
          {
            "value": "万源市"
          }
        ]
      },
      {
        "city": "雅安市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "雨城区"
          },
          {
            "value": "名山区"
          },
          {
            "value": "荥经县"
          },
          {
            "value": "汉源县"
          },
          {
            "value": "石棉县"
          },
          {
            "value": "天全县"
          },
          {
            "value": "芦山县"
          },
          {
            "value": "宝兴县"
          }
        ]
      },
      {
        "city": "巴中市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "巴州区"
          },
          {
            "value": "恩阳区"
          },
          {
            "value": "通江县"
          },
          {
            "value": "南江县"
          },
          {
            "value": "平昌县"
          }
        ]
      },
      {
        "city": "资阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "雁江区"
          },
          {
            "value": "安岳县"
          },
          {
            "value": "乐至县"
          }
        ]
      },
      {
        "city": "阿坝藏族羌族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "马尔康市"
          },
          {
            "value": "汶川县"
          },
          {
            "value": "理县"
          },
          {
            "value": "茂县"
          },
          {
            "value": "松潘县"
          },
          {
            "value": "九寨沟县"
          },
          {
            "value": "金川县"
          },
          {
            "value": "小金县"
          },
          {
            "value": "黑水县"
          },
          {
            "value": "壤塘县"
          },
          {
            "value": "阿坝县"
          },
          {
            "value": "若尔盖县"
          },
          {
            "value": "红原县"
          }
        ]
      },
      {
        "city": "甘孜藏族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "康定市"
          },
          {
            "value": "泸定县"
          },
          {
            "value": "丹巴县"
          },
          {
            "value": "九龙县"
          },
          {
            "value": "雅江县"
          },
          {
            "value": "道孚县"
          },
          {
            "value": "炉霍县"
          },
          {
            "value": "甘孜县"
          },
          {
            "value": "新龙县"
          },
          {
            "value": "德格县"
          },
          {
            "value": "白玉县"
          },
          {
            "value": "石渠县"
          },
          {
            "value": "色达县"
          },
          {
            "value": "理塘县"
          },
          {
            "value": "巴塘县"
          },
          {
            "value": "乡城县"
          },
          {
            "value": "稻城县"
          },
          {
            "value": "得荣县"
          }
        ]
      },
      {
        "city": "凉山彝族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "西昌市"
          },
          {
            "value": "会理市"
          },
          {
            "value": "木里藏族自治县"
          },
          {
            "value": "盐源县"
          },
          {
            "value": "德昌县"
          },
          {
            "value": "会东县"
          },
          {
            "value": "宁南县"
          },
          {
            "value": "普格县"
          },
          {
            "value": "布拖县"
          },
          {
            "value": "金阳县"
          },
          {
            "value": "昭觉县"
          },
          {
            "value": "喜德县"
          },
          {
            "value": "冕宁县"
          },
          {
            "value": "越西县"
          },
          {
            "value": "甘洛县"
          },
          {
            "value": "美姑县"
          },
          {
            "value": "雷波县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "贵州省",
	 "label": "贵州省",
    "children": [
      {
        "city": "贵阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "南明区"
          },
          {
            "value": "云岩区"
          },
          {
            "value": "花溪区"
          },
          {
            "value": "乌当区"
          },
          {
            "value": "白云区"
          },
          {
            "value": "观山湖区"
          },
          {
            "value": "开阳县"
          },
          {
            "value": "息烽县"
          },
          {
            "value": "修文县"
          },
          {
            "value": "清镇市"
          }
        ]
      },
      {
        "city": "六盘水市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "钟山区"
          },
          {
            "value": "六枝特区"
          },
          {
            "value": "水城区"
          },
          {
            "value": "盘州市"
          }
        ]
      },
      {
        "city": "遵义市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "红花岗区"
          },
          {
            "value": "汇川区"
          },
          {
            "value": "播州区"
          },
          {
            "value": "桐梓县"
          },
          {
            "value": "绥阳县"
          },
          {
            "value": "正安县"
          },
          {
            "value": "道真仡佬族苗族自治县"
          },
          {
            "value": "务川仡佬族苗族自治县"
          },
          {
            "value": "凤冈县"
          },
          {
            "value": "湄潭县"
          },
          {
            "value": "余庆县"
          },
          {
            "value": "习水县"
          },
          {
            "value": "赤水市"
          },
          {
            "value": "仁怀市"
          }
        ]
      },
      {
        "city": "安顺市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "西秀区"
          },
          {
            "value": "平坝区"
          },
          {
            "value": "普定县"
          },
          {
            "value": "镇宁布依族苗族自治县"
          },
          {
            "value": "关岭布依族苗族自治县"
          },
          {
            "value": "紫云苗族布依族自治县"
          }
        ]
      },
      {
        "city": "毕节市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "七星关区"
          },
          {
            "value": "大方县"
          },
          {
            "value": "金沙县"
          },
          {
            "value": "织金县"
          },
          {
            "value": "纳雍县"
          },
          {
            "value": "威宁彝族回族苗族自治县"
          },
          {
            "value": "赫章县"
          },
          {
            "value": "黔西市"
          }
        ]
      },
      {
        "city": "铜仁市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "碧江区"
          },
          {
            "value": "万山区"
          },
          {
            "value": "江口县"
          },
          {
            "value": "玉屏侗族自治县"
          },
          {
            "value": "石阡县"
          },
          {
            "value": "思南县"
          },
          {
            "value": "印江土家族苗族自治县"
          },
          {
            "value": "德江县"
          },
          {
            "value": "沿河土家族自治县"
          },
          {
            "value": "松桃苗族自治县"
          }
        ]
      },
      {
        "city": "黔西南布依族苗族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "兴义市"
          },
          {
            "value": "兴仁市"
          },
          {
            "value": "普安县"
          },
          {
            "value": "晴隆县"
          },
          {
            "value": "贞丰县"
          },
          {
            "value": "望谟县"
          },
          {
            "value": "册亨县"
          },
          {
            "value": "安龙县"
          }
        ]
      },
      {
        "city": "黔东南苗族侗族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "凯里市"
          },
          {
            "value": "黄平县"
          },
          {
            "value": "施秉县"
          },
          {
            "value": "三穗县"
          },
          {
            "value": "镇远县"
          },
          {
            "value": "岑巩县"
          },
          {
            "value": "天柱县"
          },
          {
            "value": "锦屏县"
          },
          {
            "value": "剑河县"
          },
          {
            "value": "台江县"
          },
          {
            "value": "黎平县"
          },
          {
            "value": "榕江县"
          },
          {
            "value": "从江县"
          },
          {
            "value": "雷山县"
          },
          {
            "value": "麻江县"
          },
          {
            "value": "丹寨县"
          }
        ]
      },
      {
        "city": "黔南布依族苗族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "都匀市"
          },
          {
            "value": "福泉市"
          },
          {
            "value": "荔波县"
          },
          {
            "value": "贵定县"
          },
          {
            "value": "瓮安县"
          },
          {
            "value": "独山县"
          },
          {
            "value": "平塘县"
          },
          {
            "value": "罗甸县"
          },
          {
            "value": "长顺县"
          },
          {
            "value": "龙里县"
          },
          {
            "value": "惠水县"
          },
          {
            "value": "三都水族自治县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "云南省",
	 "label": "云南省",
    "children": [
      {
        "city": "昆明市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "五华区"
          },
          {
            "value": "盘龙区"
          },
          {
            "value": "官渡区"
          },
          {
            "value": "西山区"
          },
          {
            "value": "东川区"
          },
          {
            "value": "呈贡区"
          },
          {
            "value": "晋宁区"
          },
          {
            "value": "富民县"
          },
          {
            "value": "宜良县"
          },
          {
            "value": "石林彝族自治县"
          },
          {
            "value": "嵩明县"
          },
          {
            "value": "禄劝彝族苗族自治县"
          },
          {
            "value": "寻甸回族彝族自治县"
          },
          {
            "value": "安宁市"
          }
        ]
      },
      {
        "city": "曲靖市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "麒麟区"
          },
          {
            "value": "沾益区"
          },
          {
            "value": "马龙区"
          },
          {
            "value": "陆良县"
          },
          {
            "value": "师宗县"
          },
          {
            "value": "罗平县"
          },
          {
            "value": "富源县"
          },
          {
            "value": "会泽县"
          },
          {
            "value": "宣威市"
          }
        ]
      },
      {
        "city": "玉溪市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "红塔区"
          },
          {
            "value": "江川区"
          },
          {
            "value": "通海县"
          },
          {
            "value": "华宁县"
          },
          {
            "value": "易门县"
          },
          {
            "value": "峨山彝族自治县"
          },
          {
            "value": "新平彝族傣族自治县"
          },
          {
            "value": "元江哈尼族彝族傣族自治县"
          },
          {
            "value": "澄江市"
          }
        ]
      },
      {
        "city": "保山市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "隆阳区"
          },
          {
            "value": "施甸县"
          },
          {
            "value": "龙陵县"
          },
          {
            "value": "昌宁县"
          },
          {
            "value": "腾冲市"
          }
        ]
      },
      {
        "city": "昭通市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "昭阳区"
          },
          {
            "value": "鲁甸县"
          },
          {
            "value": "巧家县"
          },
          {
            "value": "盐津县"
          },
          {
            "value": "大关县"
          },
          {
            "value": "永善县"
          },
          {
            "value": "绥江县"
          },
          {
            "value": "镇雄县"
          },
          {
            "value": "彝良县"
          },
          {
            "value": "威信县"
          },
          {
            "value": "水富市"
          }
        ]
      },
      {
        "city": "丽江市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "古城区"
          },
          {
            "value": "玉龙纳西族自治县"
          },
          {
            "value": "永胜县"
          },
          {
            "value": "华坪县"
          },
          {
            "value": "宁蒗彝族自治县"
          }
        ]
      },
      {
        "city": "普洱市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "思茅区"
          },
          {
            "value": "宁洱哈尼族彝族自治县"
          },
          {
            "value": "墨江哈尼族自治县"
          },
          {
            "value": "景东彝族自治县"
          },
          {
            "value": "景谷傣族彝族自治县"
          },
          {
            "value": "镇沅彝族哈尼族拉祜族自治县"
          },
          {
            "value": "江城哈尼族彝族自治县"
          },
          {
            "value": "孟连傣族拉祜族佤族自治县"
          },
          {
            "value": "澜沧拉祜族自治县"
          },
          {
            "value": "西盟佤族自治县"
          }
        ]
      },
      {
        "city": "临沧市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "临翔区"
          },
          {
            "value": "凤庆县"
          },
          {
            "value": "云县"
          },
          {
            "value": "永德县"
          },
          {
            "value": "镇康县"
          },
          {
            "value": "双江拉祜族佤族布朗族傣族自治县"
          },
          {
            "value": "耿马傣族佤族自治县"
          },
          {
            "value": "沧源佤族自治县"
          }
        ]
      },
      {
        "city": "楚雄彝族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "楚雄市"
          },
          {
            "value": "禄丰市"
          },
          {
            "value": "双柏县"
          },
          {
            "value": "牟定县"
          },
          {
            "value": "南华县"
          },
          {
            "value": "姚安县"
          },
          {
            "value": "大姚县"
          },
          {
            "value": "永仁县"
          },
          {
            "value": "元谋县"
          },
          {
            "value": "武定县"
          }
        ]
      },
      {
        "city": "红河哈尼族彝族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "个旧市"
          },
          {
            "value": "开远市"
          },
          {
            "value": "蒙自市"
          },
          {
            "value": "弥勒市"
          },
          {
            "value": "屏边苗族自治县"
          },
          {
            "value": "建水县"
          },
          {
            "value": "石屏县"
          },
          {
            "value": "泸西县"
          },
          {
            "value": "元阳县"
          },
          {
            "value": "红河县"
          },
          {
            "value": "金平苗族瑶族傣族自治县"
          },
          {
            "value": "绿春县"
          },
          {
            "value": "河口瑶族自治县"
          }
        ]
      },
      {
        "city": "文山壮族苗族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "文山市"
          },
          {
            "value": "砚山县"
          },
          {
            "value": "西畴县"
          },
          {
            "value": "麻栗坡县"
          },
          {
            "value": "马关县"
          },
          {
            "value": "丘北县"
          },
          {
            "value": "广南县"
          },
          {
            "value": "富宁县"
          }
        ]
      },
      {
        "city": "西双版纳傣族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "景洪市"
          },
          {
            "value": "勐海县"
          },
          {
            "value": "勐腊县"
          }
        ]
      },
      {
        "city": "大理白族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "大理市"
          },
          {
            "value": "漾濞彝族自治县"
          },
          {
            "value": "祥云县"
          },
          {
            "value": "宾川县"
          },
          {
            "value": "弥渡县"
          },
          {
            "value": "南涧彝族自治县"
          },
          {
            "value": "巍山彝族回族自治县"
          },
          {
            "value": "永平县"
          },
          {
            "value": "云龙县"
          },
          {
            "value": "洱源县"
          },
          {
            "value": "剑川县"
          },
          {
            "value": "鹤庆县"
          }
        ]
      },
      {
        "city": "德宏傣族景颇族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "瑞丽市"
          },
          {
            "value": "芒市"
          },
          {
            "value": "梁河县"
          },
          {
            "value": "盈江县"
          },
          {
            "value": "陇川县"
          }
        ]
      },
      {
        "city": "怒江傈僳族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "泸水市"
          },
          {
            "value": "福贡县"
          },
          {
            "value": "贡山独龙族怒族自治县"
          },
          {
            "value": "兰坪白族普米族自治县"
          }
        ]
      },
      {
        "city": "迪庆藏族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "香格里拉市"
          },
          {
            "value": "德钦县"
          },
          {
            "value": "维西傈僳族自治县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "西藏自治区",
	 "label": "西藏自治区",
    "children": [
      {
        "city": "拉萨市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "城关区"
          },
          {
            "value": "堆龙德庆区"
          },
          {
            "value": "达孜区"
          },
          {
            "value": "林周县"
          },
          {
            "value": "当雄县"
          },
          {
            "value": "尼木县"
          },
          {
            "value": "曲水县"
          },
          {
            "value": "墨竹工卡县"
          }
        ]
      },
      {
        "city": "日喀则市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "桑珠孜区"
          },
          {
            "value": "南木林县"
          },
          {
            "value": "江孜县"
          },
          {
            "value": "定日县"
          },
          {
            "value": "萨迦县"
          },
          {
            "value": "拉孜县"
          },
          {
            "value": "昂仁县"
          },
          {
            "value": "谢通门县"
          },
          {
            "value": "白朗县"
          },
          {
            "value": "仁布县"
          },
          {
            "value": "康马县"
          },
          {
            "value": "定结县"
          },
          {
            "value": "仲巴县"
          },
          {
            "value": "亚东县"
          },
          {
            "value": "吉隆县"
          },
          {
            "value": "聂拉木县"
          },
          {
            "value": "萨嘎县"
          },
          {
            "value": "岗巴县"
          }
        ]
      },
      {
        "city": "昌都市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "卡若区"
          },
          {
            "value": "江达县"
          },
          {
            "value": "贡觉县"
          },
          {
            "value": "类乌齐县"
          },
          {
            "value": "丁青县"
          },
          {
            "value": "察雅县"
          },
          {
            "value": "八宿县"
          },
          {
            "value": "左贡县"
          },
          {
            "value": "芒康县"
          },
          {
            "value": "洛隆县"
          },
          {
            "value": "边坝县"
          }
        ]
      },
      {
        "city": "林芝市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "巴宜区"
          },
          {
            "value": "工布江达县"
          },
          {
            "value": "米林县"
          },
          {
            "value": "墨脱县"
          },
          {
            "value": "波密县"
          },
          {
            "value": "察隅县"
          },
          {
            "value": "朗县"
          }
        ]
      },
      {
        "city": "山南市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "乃东区"
          },
          {
            "value": "扎囊县"
          },
          {
            "value": "贡嘎县"
          },
          {
            "value": "桑日县"
          },
          {
            "value": "琼结县"
          },
          {
            "value": "曲松县"
          },
          {
            "value": "措美县"
          },
          {
            "value": "洛扎县"
          },
          {
            "value": "加查县"
          },
          {
            "value": "隆子县"
          },
          {
            "value": "错那县"
          },
          {
            "value": "浪卡子县"
          }
        ]
      },
      {
        "city": "那曲市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "色尼区"
          },
          {
            "value": "嘉黎县"
          },
          {
            "value": "比如县"
          },
          {
            "value": "聂荣县"
          },
          {
            "value": "安多县"
          },
          {
            "value": "申扎县"
          },
          {
            "value": "索县"
          },
          {
            "value": "班戈县"
          },
          {
            "value": "巴青县"
          },
          {
            "value": "尼玛县"
          },
          {
            "value": "双湖县"
          }
        ]
      },
      {
        "city": "阿里地区",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "普兰县"
          },
          {
            "value": "札达县"
          },
          {
            "value": "噶尔县"
          },
          {
            "value": "日土县"
          },
          {
            "value": "革吉县"
          },
          {
            "value": "改则县"
          },
          {
            "value": "措勤县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "陕西省",
	 "label": "陕西省",
    "children": [
      {
        "city": "西安市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "新城区"
          },
          {
            "value": "碑林区"
          },
          {
            "value": "莲湖区"
          },
          {
            "value": "灞桥区"
          },
          {
            "value": "未央区"
          },
          {
            "value": "雁塔区"
          },
          {
            "value": "阎良区"
          },
          {
            "value": "临潼区"
          },
          {
            "value": "长安区"
          },
          {
            "value": "高陵区"
          },
          {
            "value": "鄠邑区"
          },
          {
            "value": "蓝田县"
          },
          {
            "value": "周至县"
          }
        ]
      },
      {
        "city": "铜川市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "王益区"
          },
          {
            "value": "印台区"
          },
          {
            "value": "耀州区"
          },
          {
            "value": "宜君县"
          }
        ]
      },
      {
        "city": "宝鸡市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "渭滨区"
          },
          {
            "value": "金台区"
          },
          {
            "value": "陈仓区"
          },
          {
            "value": "凤翔区"
          },
          {
            "value": "岐山县"
          },
          {
            "value": "扶风县"
          },
          {
            "value": "眉县"
          },
          {
            "value": "陇县"
          },
          {
            "value": "千阳县"
          },
          {
            "value": "麟游县"
          },
          {
            "value": "凤县"
          },
          {
            "value": "太白县"
          }
        ]
      },
      {
        "city": "咸阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "秦都区"
          },
          {
            "value": "杨陵区"
          },
          {
            "value": "渭城区"
          },
          {
            "value": "三原县"
          },
          {
            "value": "泾阳县"
          },
          {
            "value": "乾县"
          },
          {
            "value": "礼泉县"
          },
          {
            "value": "永寿县"
          },
          {
            "value": "长武县"
          },
          {
            "value": "旬邑县"
          },
          {
            "value": "淳化县"
          },
          {
            "value": "武功县"
          },
          {
            "value": "兴平市"
          },
          {
            "value": "彬州市"
          }
        ]
      },
      {
        "city": "渭南市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "临渭区"
          },
          {
            "value": "华州区"
          },
          {
            "value": "潼关县"
          },
          {
            "value": "大荔县"
          },
          {
            "value": "合阳县"
          },
          {
            "value": "澄城县"
          },
          {
            "value": "蒲城县"
          },
          {
            "value": "白水县"
          },
          {
            "value": "富平县"
          },
          {
            "value": "韩城市"
          },
          {
            "value": "华阴市"
          }
        ]
      },
      {
        "city": "延安市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "宝塔区"
          },
          {
            "value": "安塞区"
          },
          {
            "value": "延长县"
          },
          {
            "value": "延川县"
          },
          {
            "value": "志丹县"
          },
          {
            "value": "吴起县"
          },
          {
            "value": "甘泉县"
          },
          {
            "value": "富县"
          },
          {
            "value": "洛川县"
          },
          {
            "value": "宜川县"
          },
          {
            "value": "黄龙县"
          },
          {
            "value": "黄陵县"
          },
          {
            "value": "子长市"
          }
        ]
      },
      {
        "city": "汉中市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "汉台区"
          },
          {
            "value": "南郑区"
          },
          {
            "value": "城固县"
          },
          {
            "value": "洋县"
          },
          {
            "value": "西乡县"
          },
          {
            "value": "勉县"
          },
          {
            "value": "宁强县"
          },
          {
            "value": "略阳县"
          },
          {
            "value": "镇巴县"
          },
          {
            "value": "留坝县"
          },
          {
            "value": "佛坪县"
          }
        ]
      },
      {
        "city": "榆林市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "榆阳区"
          },
          {
            "value": "横山区"
          },
          {
            "value": "府谷县"
          },
          {
            "value": "靖边县"
          },
          {
            "value": "定边县"
          },
          {
            "value": "绥德县"
          },
          {
            "value": "米脂县"
          },
          {
            "value": "佳县"
          },
          {
            "value": "吴堡县"
          },
          {
            "value": "清涧县"
          },
          {
            "value": "子洲县"
          },
          {
            "value": "神木市"
          }
        ]
      },
      {
        "city": "安康市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "汉滨区"
          },
          {
            "value": "汉阴县"
          },
          {
            "value": "石泉县"
          },
          {
            "value": "宁陕县"
          },
          {
            "value": "紫阳县"
          },
          {
            "value": "岚皋县"
          },
          {
            "value": "平利县"
          },
          {
            "value": "镇坪县"
          },
          {
            "value": "白河县"
          },
          {
            "value": "旬阳市"
          }
        ]
      },
      {
        "city": "商洛市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "商州区"
          },
          {
            "value": "洛南县"
          },
          {
            "value": "丹凤县"
          },
          {
            "value": "商南县"
          },
          {
            "value": "山阳县"
          },
          {
            "value": "镇安县"
          },
          {
            "value": "柞水县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "甘肃省",
	 "label": "甘肃省",
    "children": [
      {
        "city": "兰州市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "城关区"
          },
          {
            "value": "七里河区"
          },
          {
            "value": "西固区"
          },
          {
            "value": "安宁区"
          },
          {
            "value": "红古区"
          },
          {
            "value": "永登县"
          },
          {
            "value": "皋兰县"
          },
          {
            "value": "榆中县"
          }
        ]
      },
      {
        "city": "金昌市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "金川区"
          },
          {
            "value": "永昌县"
          }
        ]
      },
      {
        "city": "白银市",
        "children": [
          {
            "value": "白银区"
          },
          {
            "value": "平川区"
          },
          {
            "value": "靖远县"
          },
          {
            "value": "会宁县"
          },
          {
            "value": "景泰县"
          }
        ]
      },
      {
        "city": "天水市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "秦州区"
          },
          {
            "value": "麦积区"
          },
          {
            "value": "清水县"
          },
          {
            "value": "秦安县"
          },
          {
            "value": "甘谷县"
          },
          {
            "value": "武山县"
          },
          {
            "value": "张家川回族自治县"
          }
        ]
      },
      {
        "city": "武威市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "凉州区"
          },
          {
            "value": "民勤县"
          },
          {
            "value": "古浪县"
          },
          {
            "value": "天祝藏族自治县"
          }
        ]
      },
      {
        "city": "张掖市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "甘州区"
          },
          {
            "value": "肃南裕固族自治县"
          },
          {
            "value": "民乐县"
          },
          {
            "value": "临泽县"
          },
          {
            "value": "高台县"
          },
          {
            "value": "山丹县"
          }
        ]
      },
      {
        "city": "平凉市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "崆峒区"
          },
          {
            "value": "泾川县"
          },
          {
            "value": "灵台县"
          },
          {
            "value": "崇信县"
          },
          {
            "value": "庄浪县"
          },
          {
            "value": "静宁县"
          },
          {
            "value": "华亭市"
          }
        ]
      },
      {
        "city": "酒泉市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "肃州区"
          },
          {
            "value": "金塔县"
          },
          {
            "value": "瓜州县"
          },
          {
            "value": "肃北蒙古族自治县"
          },
          {
            "value": "阿克塞哈萨克族自治县"
          },
          {
            "value": "玉门市"
          },
          {
            "value": "敦煌市"
          }
        ]
      },
      {
        "city": "庆阳市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "西峰区"
          },
          {
            "value": "庆城县"
          },
          {
            "value": "环县"
          },
          {
            "value": "华池县"
          },
          {
            "value": "合水县"
          },
          {
            "value": "正宁县"
          },
          {
            "value": "宁县"
          },
          {
            "value": "镇原县"
          }
        ]
      },
      {
        "city": "定西市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "安定区"
          },
          {
            "value": "通渭县"
          },
          {
            "value": "陇西县"
          },
          {
            "value": "渭源县"
          },
          {
            "value": "临洮县"
          },
          {
            "value": "漳县"
          },
          {
            "value": "岷县"
          }
        ]
      },
      {
        "city": "陇南市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "武都区"
          },
          {
            "value": "成县"
          },
          {
            "value": "文县"
          },
          {
            "value": "宕昌县"
          },
          {
            "value": "康县"
          },
          {
            "value": "西和县"
          },
          {
            "value": "礼县"
          },
          {
            "value": "徽县"
          },
          {
            "value": "两当县"
          }
        ]
      },
      {
        "city": "临夏回族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "临夏市"
          },
          {
            "value": "临夏县"
          },
          {
            "value": "康乐县"
          },
          {
            "value": "永靖县"
          },
          {
            "value": "广河县"
          },
          {
            "value": "和政县"
          },
          {
            "value": "东乡族自治县"
          },
          {
            "value": "积石山保安族东乡族撒拉族自治县"
          }
        ]
      },
      {
        "city": "甘南藏族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "合作市"
          },
          {
            "value": "临潭县"
          },
          {
            "value": "卓尼县"
          },
          {
            "value": "舟曲县"
          },
          {
            "value": "迭部县"
          },
          {
            "value": "玛曲县"
          },
          {
            "value": "碌曲县"
          },
          {
            "value": "夏河县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "青海省",
	 "label": "青海省",
    "children": [
      {
        "city": "西宁市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "城东区"
          },
          {
            "value": "城中区"
          },
          {
            "value": "城西区"
          },
          {
            "value": "城北区"
          },
          {
            "value": "湟中区"
          },
          {
            "value": "大通回族土族自治县"
          },
          {
            "value": "湟源县"
          }
        ]
      },
      {
        "city": "海东市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "乐都区"
          },
          {
            "value": "平安区"
          },
          {
            "value": "民和回族土族自治县"
          },
          {
            "value": "互助土族自治县"
          },
          {
            "value": "化隆回族自治县"
          },
          {
            "value": "循化撒拉族自治县"
          }
        ]
      },
      {
        "city": "海北藏族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "门源回族自治县"
          },
          {
            "value": "祁连县"
          },
          {
            "value": "海晏县"
          },
          {
            "value": "刚察县"
          }
        ]
      },
      {
        "city": "黄南藏族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "同仁市"
          },
          {
            "value": "尖扎县"
          },
          {
            "value": "泽库县"
          },
          {
            "value": "河南蒙古族自治县"
          }
        ]
      },
      {
        "city": "海南藏族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "共和县"
          },
          {
            "value": "同德县"
          },
          {
            "value": "贵德县"
          },
          {
            "value": "兴海县"
          },
          {
            "value": "贵南县"
          }
        ]
      },
      {
        "city": "果洛藏族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "玛沁县"
          },
          {
            "value": "班玛县"
          },
          {
            "value": "甘德县"
          },
          {
            "value": "达日县"
          },
          {
            "value": "久治县"
          },
          {
            "value": "玛多县"
          }
        ]
      },
      {
        "city": "玉树藏族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "玉树市"
          },
          {
            "value": "杂多县"
          },
          {
            "value": "称多县"
          },
          {
            "value": "治多县"
          },
          {
            "value": "囊谦县"
          },
          {
            "value": "曲麻莱县"
          }
        ]
      },
      {
        "city": "海西蒙古族藏族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "格尔木市"
          },
          {
            "value": "德令哈市"
          },
          {
            "value": "茫崖市"
          },
          {
            "value": "乌兰县"
          },
          {
            "value": "都兰县"
          },
          {
            "value": "天峻县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "宁夏回族自治区",
	 "label": "宁夏回族自治区",
    "children": [
      {
        "city": "银川市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "兴庆区"
          },
          {
            "value": "西夏区"
          },
          {
            "value": "金凤区"
          },
          {
            "value": "永宁县"
          },
          {
            "value": "贺兰县"
          },
          {
            "value": "灵武市"
          }
        ]
      },
      {
        "city": "石嘴山市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "大武口区"
          },
          {
            "value": "惠农区"
          },
          {
            "value": "平罗县"
          }
        ]
      },
      {
        "city": "吴忠市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "利通区"
          },
          {
            "value": "红寺堡区"
          },
          {
            "value": "盐池县"
          },
          {
            "value": "同心县"
          },
          {
            "value": "青铜峡市"
          }
        ]
      },
      {
        "city": "固原市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "原州区"
          },
          {
            "value": "西吉县"
          },
          {
            "value": "隆德县"
          },
          {
            "value": "泾源县"
          },
          {
            "value": "彭阳县"
          }
        ]
      },
      {
        "city": "中卫市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "沙坡头区"
          },
          {
            "value": "中宁县"
          },
          {
            "value": "海原县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "新疆维吾尔自治区",
	 "label": "新疆维吾尔自治区",
    "children": [
      {
        "city": "乌鲁木齐市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "天山区"
          },
          {
            "value": "沙依巴克区"
          },
          {
            "value": "新市区"
          },
          {
            "value": "水磨沟区"
          },
          {
            "value": "头屯河区"
          },
          {
            "value": "达坂城区"
          },
          {
            "value": "米东区"
          },
          {
            "value": "乌鲁木齐县"
          }
        ]
      },
      {
        "city": "克拉玛依市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "独山子区"
          },
          {
            "value": "克拉玛依区"
          },
          {
            "value": "白碱滩区"
          },
          {
            "value": "乌尔禾区"
          }
        ]
      },
      {
        "city": "吐鲁番市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "高昌区"
          },
          {
            "value": "鄯善县"
          },
          {
            "value": "托克逊县"
          }
        ]
      },
      {
        "city": "哈密市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "伊州区"
          },
          {
            "value": "巴里坤哈萨克自治县"
          },
          {
            "value": "伊吾县"
          }
        ]
      },
      {
        "city": "昌吉回族自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "昌吉市"
          },
          {
            "value": "阜康市"
          },
          {
            "value": "呼图壁县"
          },
          {
            "value": "玛纳斯县"
          },
          {
            "value": "奇台县"
          },
          {
            "value": "吉木萨尔县"
          },
          {
            "value": "木垒哈萨克自治县"
          }
        ]
      },
      {
        "city": "博尔塔拉蒙古自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "博乐市"
          },
          {
            "value": "阿拉山口市"
          },
          {
            "value": "精河县"
          },
          {
            "value": "温泉县"
          }
        ]
      },
      {
        "city": "巴音郭楞蒙古自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "库尔勒市"
          },
          {
            "value": "轮台县"
          },
          {
            "value": "尉犁县"
          },
          {
            "value": "若羌县"
          },
          {
            "value": "且末县"
          },
          {
            "value": "焉耆回族自治县"
          },
          {
            "value": "和静县"
          },
          {
            "value": "和硕县"
          },
          {
            "value": "博湖县"
          }
        ]
      },
      {
        "city": "阿克苏地区",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "阿克苏市"
          },
          {
            "value": "库车市"
          },
          {
            "value": "温宿县"
          },
          {
            "value": "沙雅县"
          },
          {
            "value": "新和县"
          },
          {
            "value": "拜城县"
          },
          {
            "value": "乌什县"
          },
          {
            "value": "阿瓦提县"
          },
          {
            "value": "柯坪县"
          }
        ]
      },
      {
        "city": "克孜勒苏柯尔克孜自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "阿图什市"
          },
          {
            "value": "阿克陶县"
          },
          {
            "value": "阿合奇县"
          },
          {
            "value": "乌恰县"
          }
        ]
      },
      {
        "city": "喀什地区",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "喀什市"
          },
          {
            "value": "疏附县"
          },
          {
            "value": "疏勒县"
          },
          {
            "value": "英吉沙县"
          },
          {
            "value": "泽普县"
          },
          {
            "value": "莎车县"
          },
          {
            "value": "叶城县"
          },
          {
            "value": "麦盖提县"
          },
          {
            "value": "岳普湖县"
          },
          {
            "value": "伽师县"
          },
          {
            "value": "巴楚县"
          },
          {
            "value": "塔什库尔干塔吉克自治县"
          }
        ]
      },
      {
        "city": "和田地区",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "和田市"
          },
          {
            "value": "和田县"
          },
          {
            "value": "墨玉县"
          },
          {
            "value": "皮山县"
          },
          {
            "value": "洛浦县"
          },
          {
            "value": "策勒县"
          },
          {
            "value": "于田县"
          },
          {
            "value": "民丰县"
          }
        ]
      },
      {
        "city": "伊犁哈萨克自治州",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "伊宁市"
          },
          {
            "value": "奎屯市"
          },
          {
            "value": "霍尔果斯市"
          },
          {
            "value": "伊宁县"
          },
          {
            "value": "察布查尔锡伯自治县"
          },
          {
            "value": "霍城县"
          },
          {
            "value": "巩留县"
          },
          {
            "value": "新源县"
          },
          {
            "value": "昭苏县"
          },
          {
            "value": "特克斯县"
          },
          {
            "value": "尼勒克县"
          }
        ]
      },
      {
        "city": "塔城地区",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "塔城市"
          },
          {
            "value": "乌苏市"
          },
          {
            "value": "沙湾市"
          },
          {
            "value": "额敏县"
          },
          {
            "value": "托里县"
          },
          {
            "value": "裕民县"
          },
          {
            "value": "和布克赛尔蒙古自治县"
          }
        ]
      },
      {
        "city": "阿勒泰地区",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "阿勒泰市"
          },
          {
            "value": "布尔津县"
          },
          {
            "value": "富蕴县"
          },
          {
            "value": "福海县"
          },
          {
            "value": "哈巴河县"
          },
          {
            "value": "青河县"
          },
          {
            "value": "吉木乃县"
          },
          {
            "value": "石河子市"
          },
          {
            "value": "阿拉尔市"
          },
          {
            "value": "图木舒克市"
          },
          {
            "value": "五家渠市"
          },
          {
            "value": "北屯市"
          },
          {
            "value": "铁门关市"
          },
          {
            "value": "双河市"
          },
          {
            "value": "可克达拉市"
          },
          {
            "value": "昆玉市"
          },
          {
            "value": "胡杨河市"
          },
          {
            "value": "新星市"
          }
        ]
      }
    ]
  },
  
  {
    "value": "台湾省",
	 "label": "台湾省",
    "children": [
      {
        "city": "台北市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "台北市"
          }
        ]
      },
      {
        "city": "新北市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "新北市"
          }
        ]
      },
      {
        "city": "桃园市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "桃园市"
          }
        ]
      },
      {
        "city": "台中市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "台中市"
          }
        ]
      },
      {
        "city": "台南市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "台南市"
          }
        ]
      },
      {
        "city": "高雄市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "高雄市"
          }
        ]
      },
      {
        "city": "基隆市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "基隆市"
          }
        ]
      },
      {
        "city": "新竹市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "新竹市"
          }
        ]
      },
      {
        "city": "嘉义市",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "嘉义市"
          }
        ]
      },
      {
        "city": "新竹县",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "新竹县"
          }
        ]
      },
      {
        "city": "苗栗县",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "苗栗县"
          }
        ]
      },
      {
        "city": "彰化县",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "彰化县"
          }
        ]
      },
      {
        "city": "南投县",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "南投县"
          }
        ]
      },
      {
        "city": "云林县",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "云林县"
          }
        ]
      },
      {
        "city": "嘉义县",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "嘉义县"
          }
        ]
      },
      {
        "city": "屏东县",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "屏东县"
          }
        ]
      },
      {
        "city": "宜兰县",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "宜兰县"
          }
        ]
      },
      {
        "city": "花莲县",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "花莲县"
          }
        ]
      },
      {
        "city": "台东县",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "台东县"
          }
        ]
      },
      {
        "city": "澎湖县",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "澎湖县"
          }
        ]
      },
      {
        "city": "连江县",
		  "value": "无锡市",
		  "label": "无锡市",
        "children": [
          {
            "value": "连江县"
          }
        ]
      }
    ]
  },
  
  {
    "value": "香港特别行政区",
	 "label": "香港特别行政区",
    "children": [
      {
        "city": "香港特别行政区",
		  "value": "香港特别行政区",
		  "label": "香港特别行政区",
        "children": [
          {
            "value": "中西区"
          },
          {
            "value": "东区"
          },
          {
            "value": "南区"
          },
          {
            "value": "湾仔区"
          },
          {
            "value": "九龙城区"
          },
          {
            "value": "深水埗区"
          },
          {
            "value": "黄大仙区"
          },
          {
            "value": "油尖旺区"
          },
          {
            "value": "离岛区"
          },
          {
            "value": "葵青区"
          },
          {
            "value": "北区"
          },
          {
            "value": "西贡区"
          },
          {
            "value": "沙田区"
          },
          {
            "value": "大埔区"
          },
          {
            "value": "荃湾区"
          },
          {
            "value": "屯门区"
          },
          {
            "value": "元朗区"
          }
        ]
      }
    ]
  },
  
  {
    "value": "澳门特别行政区",
	 "label": "澳门特别行政区",
    "children": [
      {
        "city": "澳门特别行政区",
		  "value": "澳门特别行政区",
		  "label": "澳门特别行政区",
        "children": [
          {
            "value": "花地玛堂区"
          },
          {
            "value": "圣安多尼堂区"
          },
          {
            "value": "大堂区"
          },
          {
            "value": "望德堂区"
          },
          {
            "value": "风顺堂区"
          },
          {
            "value": "氹仔"
          },
          {
            "value": "路环岛"
          }
        ]
      }
    ]
  }
  
]

export { ChinaCitys }
